/* eslint-disable eqeqeq */


import axios from 'axios'
import { useCallback, useEffect, useRef, useState, Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from "react-toastify";
import Skeleton from 'react-loading-skeleton'
import { useParams } from 'react-router-dom'
import { SwiperSlide, Swiper } from 'swiper/react'
import { Link } from 'react-router-dom';
import SimpleButton from "../../components/_input/SimpleButton";
import Popup from '../../components/popup'
import PopupWithHeading from '../../components/popupWithHeading'
import config from '../../configuration/config.json'
import SMSCheck from '../cart/components/smsCheck';
import { Price } from "../../components/__simple/_price";
import './index.css'
import Navbar from './navbar'
import Table from 'react-bootstrap/Table';
import CenterInfo from "../fixAgreement/center_Info";
import moment from "moment/moment";

const JobCard = ({ }) => {
  const { t: trans, i18n } = useTranslation(['mobileCommon', 'new', 'jobCard'])
  let lang = i18n.language
  const popRef = useRef(null)
  const [termsSalesOrders, setTermsSalesOrders] = useState([])
  const [groups, setGroups] = useState([])
  const [entityGroups, setEntityGroups] = useState([])
  const [indexPanel, setIndexPanel] = useState('4000')
  const [showPanel, setShowPanel] = useState(true)
  const [showTermsPopup, setShowTermsPopup] = useState(false)
  const { number } = useParams();
  const [isLoadingStatus, setIsLoadingStatus] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingApple, setIsLoadingApple] = useState(false);
  const [sadadInfo, setSadadInfo] = useState(null);
  const [showFinalPopup, setShowFinalPopup] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [paymentType, setPaymentType] = useState(null);
  const [optionTitle, setOptionTitle] = useState('');
  const [MessageError, setMessageError] = useState(null);

  const [mntid, setMntid] = useState();
  const [jobCardInfo, setJobCardInfo] = useState();
  const [jobCardAmounts, setJobCardAmounts] = useState();

  const [jobCardInfoSummary, setJobCardInfoSummary] = useState();

  const [showInfo, setShowInfo] = useState(true);
  const [agreementShow, setAgreementShow] = useState(true);

  const [platformTypes, setPlatformTypes] = useState([]);

  useEffect(() => {

    if (jobCardAmounts && jobCardAmounts["numberNet"]) {

      // Dynamically load the script
      const script = document.createElement('script');
      script.src = 'https://checkout.tabby.ai/tabby-promo.js';
      script.async = true;

      script.onload = () => {
        // Ensure TabbyPromo is available globally
        if (window.TabbyPromo) {
          new window.TabbyPromo({
            selector: '#TabbyPromo',
            currency: 'SAR',
            price: jobCardAmounts["numberNet"].toFixed(2),
            lang: lang,
            source: 'product',
            publicKey: 'pk_test_20b124e0-15bd-4234-b114-17460fd843b8',
            merchantCode: 'HJKSA',
            // shouldInheritBg:false
          });
        }
      };

      document.body.appendChild(script);

      // Clean up script on component unmount
      return () => {
        document.body.removeChild(script);
      };
    }

  }, [jobCardAmounts]);

  useEffect(() => {
    // تحميل الملف من مجلد public
    const loadManifest = async () => {
      try {
        const response = await fetch(`${process.env.PUBLIC_URL}/config.json`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        // Filter and map to extract keys with isActive = true
        var platformsTypes = data.platformsTypes || [];
        const activeKeys = platformsTypes
          .filter((platform) => platform.isActive)
          .map((platform) => platform.key);

        ////console.log("Active keys:", activeKeys);

        setPlatformTypes(activeKeys);

      } catch (error) {
        console.error("Error loading manifest.json:", error);
      }
    };

    loadManifest();
  }, []);
  const guestRequests = [
    {
      number: 1,
      cost: 500,
      agree: false,
    },
    {
      number: 2,
      cost: 1200,
      agree: true,
    },
    {
      number: 3,
      cost: 1000,
      agree: false,
    },
  ]


  const guestRequests2 = [
    {
      number: 1,
      cost: 500,
      agree: false,
    },
    {
      number: 2,
      cost: 1200,
      agree: true,
    },
    {
      number: 3,
      cost: 1000,
      agree: false,
    },
  ]

  const [checkedState, setCheckedState] = useState(
    new Array(guestRequests.length).fill(false)
  );


  const [checkedState2, setCheckedState2] = useState(
    new Array(guestRequests2.length).fill(false)
  );
  const [checkedState1, setCheckedState1] = useState(
    new Array(entityGroups.length).fill(false)
  );

  const [cinderInfo, setCinderInfo] = useState({});

  const [total, setTotal] = useState(0);
  const [total1, setTotal1] = useState(0);
  const [totalNet1, setTotalNet1] = useState(0);
  const [totalDescount, setTotalDescount] = useState(0);
  const [totalTaxes, setTotalTaxes] = useState(0);
  const [total2, setTotal2] = useState(0);

  const params = useParams();

  const handleOnChange = (position) => {
    const updatedCheckedState = checkedState.map((item, index) =>
      index === position ? !item : item
    );
    ////console.log('lang:', lang);

    setCheckedState(updatedCheckedState);

    const totalPrice = updatedCheckedState.reduce(
      (sum, currentState, index) => {
        if (currentState === true) {
          return sum + (guestRequests[index].cost * guestRequests[index].number);
        }
        return sum;
      },
      0
    );
    //  totalPrice = totalPrice +total;
    setTotal(totalPrice);
  };

  const [additionalList, setAdditionalList] = useState([]);
  const [groupsAdditionalList, setGroupsAdditionalList] = useState([]);
  const [infoAdditionalHeader, setInfoAdditionalHeader] = useState({});
  const [totalAfterAdditional, setTotalAfterAdditional] = useState({});
  const [postedDate, setPostedDate] = useState('');

  const [isPayed, setIsPayed] = useState(1)


  const handleOnChange1Groups = (Group, checked) => {


    let listofGroup = [];
    let numberNet = 0;
    let numberTotalBefore = 0;
    let numberDiscount = 0;
    let numberTax = 0;
    const updatedEntityGroups = entityGroups.map((item, index) => {
      if (item.Group == Group) {
        item.Approved = checked;
        // break;

      }

      try {

        if (item.Approved) {
          numberNet = numberNet + item['Net Total'];
          numberTotalBefore = numberTotalBefore + item['Total Before Discount'];
          numberDiscount = numberDiscount + item['Discount'];
          numberTax = numberTax + item['Tax Amount'];
        }

      } catch (error) {

      }

      if (!listofGroup.includes(item.Group) && item.Approved == false) {

        listofGroup.push(item.Group);

      }

      return item;
    }
    );


    let amounts = {
      "numberNet": numberNet,
      "numberTotalBefore": numberTotalBefore,
      "numberDiscount": numberDiscount,
      "numberTax": numberTax
    }

    setJobCardAmounts(amounts);


    setEntityGroups([...updatedEntityGroups]);


    const updatedGroups = groups.map((item, index) => {
      if (listofGroup.includes(item.group)) {
        item.Approved = false;
        // break;
      } else {
        item.Approved = true;

      }

      return item;
    }
    );

    setGroups([...updatedGroups]);

  }
  const handleOnChange1 = (position, GUID, checked, Qty, Total) => {


    let numberNet = 0;
    let numberTotalBefore = 0;
    let numberDiscount = 0;
    let numberTax = 0;


    let listofGroup = [];
    const updatedEntityGroups = entityGroups.map((item, index) => {
      if (item.GUID == GUID) {
        item.Approved = checked;
        // break;
      }

      try {

        if (item.Approved) {
          numberNet = numberNet + item['Net Total'];
          numberTotalBefore = numberTotalBefore + item['Total Before Discount'];
          numberDiscount = numberDiscount + item['Discount'];
          numberTax = numberTax + item['Tax Amount'];
        }

      } catch (error) {

      }


      if (!listofGroup.includes(item.Group) && item.Approved == false) {

        listofGroup.push(item.Group);

      }

      return item;

    }
    );

    let amounts = {
      "numberNet": numberNet,
      "numberTotalBefore": numberTotalBefore,
      "numberDiscount": numberDiscount,
      "numberTax": numberTax
    }

    setJobCardAmounts(amounts);

    setEntityGroups([...updatedEntityGroups]);

    const updatedGroups = groups.map((item, index) => {
      if (listofGroup.includes(item.group)) {
        item.Approved = false;
        // break;
      } else {
        item.Approved = true;

      }

      return item;
    }
    );

    setGroups([...updatedGroups]);

  };

  const handleOnChange2 = (position) => {
    const updatedCheckedState2 = checkedState2.map((item, index) =>
      index === position ? !item : item
    );

    setCheckedState2(updatedCheckedState2);

    const totalPrice2 = updatedCheckedState2.reduce(
      (sum, currentState, index) => {
        if (currentState === true) {
          return sum + (guestRequests2[index].cost * guestRequests2[index].number);
        }
        return sum;
      },
      0
    );
    // totalPrice1 = totalPrice1 +total;
    ////console.log('totalPrice2:', totalPrice2)
    setTotal2(totalPrice2);
  };


  const getIsExpireDate = async (date) => {

    try {

      const date1 = new Date(date);
      const date2 = new Date();
      ////console.log("date1", date1);
      ////console.log("date2", date2);
      const diffTime = date1 - date2;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      ////console.log(diffTime + " milliseconds");
      ////console.log(diffDays + " days");

      if (diffDays <= 0 && diffTime <= 0) {
        return true;

      } else {

        return false;
      }

    } catch (error) {
      ////console.log("error:", error);
      return true

    }

  }

  const [orderStatusCode, setOrderStatusCode] = useState("");
  const FetchDataOrder = async () => {
    // await callGetPaymetStatues();
    // await PaymentPaytabsStatusFully();
    await callPaymentStatus();
    // await getInfoAdditionalsLines();

    ////console.log('FetchDataSalesOrder>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = {

        "GUID": number
      };
      await axios.request({
        baseURL: config.controllerUrl,
        url: "/sadad/api/sadad/JobCardInfo",
        headers: myHeaders,
        data: raw, method: "POST", responseType: "json"
      })

        .then(async response => {
          ////console.log('JobCardInfo respons:', response.data);
          setJobCardInfo(response.data);
          setMntid(response.data.MaintenanceOrderID);

          if (response.data['Reception Number'] != null || response.data['Reception Number'] != "") {
            await GetCenterInfo(response.data['Reception Number']);
            await funcCheckcustomer(number);
            await GetTamaraStatus(number);
          }


          var OrderStatus = response?.data['Order Status'];
          ////console.log('OrderStatus:', OrderStatus);
          // var expirdate = await getIsExpireDate(response?.data[0]?.Expirdate)
          // ////console.log("expirdate:", expirdate);
          // if (expirdate) {
          //   setOrderStatusCode("expired");
          //   setShowFinalPopup(true);
          //   // setOrderStatusCode("ready");
          //   //       PaymentStatus();
          // } else {


          let dataTerms;
          if (response?.data?.TermsConditionsAr != null && response?.data?.TermsConditionsAr != '') {
            let TermBefor = lang == 'ar'
              ? response?.data?.TermsConditionsAr
              : response?.data?.TermsConditionsEn;

            let TermAfter = TermBefor.toString().replaceAll("\\n", "\n").split('\n');

            dataTerms = TermAfter;
            setTermsSalesOrders(dataTerms);
          }
          // else setTermsSalesOrders(["22222222222"]);

          //todo : ======
          ////console.log("< <<OrderStatus: >>>>>>>>>>>>>>>>>>>>>>>>>>", OrderStatus);
          if (OrderStatus == "Approved" || OrderStatus == "Open wait Approval" || OrderStatus == "InProcess" ||
            OrderStatus == "Ready to Release" || OrderStatus == "Under Test" || OrderStatus == "SentForPayment") {
            setOrderStatusCode("Approved");
            PaymentStatus();

          } else if (OrderStatus == "Canceled") {
            setOrderStatusCode("Canceled");
            setShowFinalPopup(true);
            PaymentStatus();

          } else if (OrderStatus == "Open") {
            setOrderStatusCode("notCorrect");
            setShowFinalPopup(true);

          } else if (OrderStatus == "Confirmed" || OrderStatus == "Closed") {
            setOrderStatusCode("Confirmed");
            PaymentStatus();

          } else {
            setOrderStatusCode("notCorrect");
            setShowFinalPopup(true);
            // PaymentStatus();

          }


        })
        .catch(function (error) {

          setOrderStatusCode("notFound");
          setShowFinalPopup(true);
          ////console.log(error);
        });
    } catch (error) {
      ////console.log("error:", error);
    }

  }

  //PaymentMAin for changes
  async function callPaymentStatus() {
    ////console.log('callPaymentStatus@>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
    setIsLoadingStatus(true);
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = {

        "GUID": number
      };
      // todo: الدفع  ..........
      await axios.request({
        baseURL: config.controllerUrl,
        url: "sadad/api/sadad/PaymentStatusMT",
        headers: myHeaders,
        data: raw, method: "POST", responseType: "json"
      }).then(async response => {
        ////console.log('PaymentStatus>>>>> respons,data >>>>>>:', response.data);
        if (response.status >= 200 && response.status <= 299) {
          await getInfoAdditionalsLines();
          if (response?.data && response?.data.status == 0) {
            ////console.log('SadadNumber respons.data.status:', response.data.status);
            setIsPayed(response?.data.status);

            if (response?.data.PaymentMethodID == 'Sadad') {

              var invoiceID = response.data.SadadNumber.replaceAll('"', "");
              try {
                if (invoiceID && parseInt(invoiceID)) {
                  var datasadad = response.data;
                  datasadad.SadadNumber = invoiceID;
                  setSadadInfo(datasadad);
                } else {
                  setSadadInfo(response?.data);
                }
              } catch (error) {
                ////console.log("statuse 200 catch error", error);
                setSadadInfo(response.data);
                ////console.log("error invoiceID:", error);
              }
              //! اهمم مرحلة في الفحص
              if (invoiceID != null && invoiceID != undefined) {
                // setShowFinalPopup(true);
              } else {
                ////console.log("await callback()");
                // await callback();
              }
              setIsLoadingStatus(false);
            }

            // else if(response.data.PaymentMethodID == 'PayTabs'){
            //   setShowFinalPopup(true);
            // }
            // else if(response.data.PaymentMethodID == ''){
            //
            // }

            // else {
            //   setShowFinalPopup(true);
            // }

            // if(response.data.SadadNumber != null || response.data.SadadNumber != undefined){
            //   ////console.log('SadadNumber respons.data.SadadNumber:', response.data.SadadNumber);
            //   setSadadInfo(parseInt(response.data.SadadNumber));

            // setShowFinalPopup(true);
          }
        }
        setIsLoadingStatus(false);
      }).catch(async error => {
        ////console.log('error PaymentStatus:', error)
        setIsLoadingStatus(false);
      });
    } catch (error) {
      ////console.log('error', error)
      setIsLoadingStatus(false);

    }
  }

  async function callGetPaymetStatues() {
    ////console.log('GetPaymetStatues >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
    setIsLoadingStatus(true);
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = {
        "GUID": number
      };

      await axios.request({
        baseURL: config.controllerUrl,
        url: "sadad/api/sadad/GetPaymetStatues",
        headers: myHeaders,
        data: raw, method: "POST", responseType: "json"
      }).then(async response => {
        ////console.log('GetPaymetStatues respons:', response);

        if (response.status >= 200 && response.status <= 299) {
          ////console.log("GetPaymetStatues >> response.data >>>>>>>>>>>", response.data);
          if (response.data.StatusPayment == 'paid') {
            ////console.log("GetPaymetStatues >> response.data.StatusPayment == paid ", response.data.StatusPayment);
            PaymentPaytabsStatusFully();
          }
        }
        setIsLoadingStatus(false);

      }
      )
        //     .then((response) => {
        //   ////console.log('GetPaymetStatues', response);
        // })
        .catch(async error => {
          ////console.log('error GetPaymetStatues:', error)
          setIsLoadingStatus(false);
        });
    } catch (error) {
      ////console.log('error', error)
      setIsLoadingStatus(false);

    }
  }

  // * PaymentPaytabsStatusFully
  async function PaymentMyFatoorahStatusFully() {
    ////console.log('PaymentMyFatoorahStatusFully >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
    setIsLoadingStatus(true);
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = {
        "GUID": number
      };

      await axios.request({
        baseURL: config.controllerUrl,
        url: "sadad/api/sadad/PaymentMyFatoorahStatusFully",
        headers: myHeaders,
        data: raw, method: "POST", responseType: "json"
      }).then(async response => {
        ////console.log('PaymentMyFatoorahStatusFully respons:', response);

        if (response.status >= 200 && response.status <= 299) {
          ////console.log("PaymentMyFatoorahStatusFully >> response.data >>>>>>>>>>>", response.data);
          if (response.data.SuccessMessage != null) {
            ////console.log("PaymentMyFatoorahStatusFully >> response.data.Message", response.data.SuccessMessage);
            setShowFinalPopup(true);
          }
        }
        setIsLoadingStatus(false);

      }
      )
        //     .then((response) => {
        //   ////console.log('GetPaymetStatues', response);
        // })
        .catch(async error => {
          ////console.log('error PaymentMyFatoorahStatusFully:', error)
          setIsLoadingStatus(false);
        });
    } catch (error) {
      ////console.log('error', error)
      setIsLoadingStatus(false);

    }
  }
  // * PaymentPaytabsStatusFully
  async function PaymentPaytabsStatusFully() {
    ////console.log('PaymentPaytabsStatusFully >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
    setIsLoadingStatus(true);
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = {
        "GUID": number
      };

      await axios.request({
        baseURL: config.controllerUrl,
        url: "sadad/api/sadad/PaymentPaytabsStatusFully",
        headers: myHeaders,
        data: raw, method: "POST", responseType: "json"
      }).then(async response => {
        ////console.log('PaymentPaytabsStatusFully respons:', response);

        if (response.status >= 200 && response.status <= 299) {
          ////console.log("PayPtabsStatusFully >> response.data >>>>>>>>>>>", response.data);
          if (response.data.SuccessMessage != null) {
            ////console.log("PayPtabsStatusFully >> response.data.Message", response.data.SuccessMessage);
            setShowFinalPopup(true);
          }
        }
        setIsLoadingStatus(false);

      }
      )
        //     .then((response) => {
        //   ////console.log('GetPaymetStatues', response);
        // })
        .catch(async error => {
          ////console.log('error PaymentPaytabsStatusFully:', error)
          setIsLoadingStatus(false);
        });
    } catch (error) {
      ////console.log('error', error)
      setIsLoadingStatus(false);

    }
  }

  // * PaymentPaytabsStatusPartially
  async function paymentPaytabsStatusPartially() {
    ////console.log('PaymentPaytabsStatusPartially >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
    setIsLoadingStatus(true);
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = {
        "GUID": number
      };

      await axios.request({
        baseURL: config.controllerUrl,
        url: "sadad/api/sadad/PaymentPaytabsStatusPartially",
        headers: myHeaders,
        data: raw, method: "POST", responseType: "json"
      }).then(async response => {
        ////console.log('PaymentPaytabsStatusPartially respons:', response);

        if (response.status >= 200 && response.status <= 299) {
          ////console.log("PaymentPaytabsStatusPartially >> response.data >>>>>>>>>>>", response.data);
          if (response.data.SuccessMessage != null) {
            ////console.log("PaymentPaytabsStatusPartially >> response.data.Message", response.data.SuccessMessage);
            setShowFinalPopup(true);
          }
        }
        setIsLoadingStatus(false);

      }
      ).catch(async error => {
        ////console.log('error PaymentPaytabsStatusPartially:', error)
        setIsLoadingStatus(false);
      });
    } catch (error) {
      ////console.log('error', error)
      setIsLoadingStatus(false);

    }
  }

  // * CreateSadadCodeMT sadad
  const CreateSadadCodeMT = async () => {
    ////console.log('PaymentPaytabsStatusPartially >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
    setIsLoadingStatus(true);
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = {
        "GUID": number
      };

      await axios.request({
        baseURL: config.controllerUrl,
        url: "sadad/api/sadad/CreateSadadCodeMT",
        headers: myHeaders,
        data: raw, method: "POST", responseType: "json"
      }).then(async response => {
        ////console.log('CreateSadadCodeMT respons:', response);

        if (response.status >= 200 && response.status <= 299) {
          ////console.log("CreateSadadCodeMT >> response.data >>>>>>>>>>>", response.data);
          if (response.data.sadadMessage != null || response.data.sadadMessage != '') {
            toast.error(trans("messages:error_after_select") + " " + trans("messages:sadad"));
          }


          var invoiceID = response.data.sadadNumber.replaceAll('"', "");

          try {
            if (invoiceID && parseInt(invoiceID)) {
              var datasadad = response.data;
              datasadad.SadadNumber = invoiceID;
              setSadadInfo(datasadad);
              ////console.log("VVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV:", invoiceID)
            } else {
              setSadadInfo(response?.data);
            }
          } catch (error) {
            ////console.log("statuse 200 catch error", error);
            setSadadInfo(response.data);
            ////console.log("error invoiceID:", error);
          }
          //! اهمم مرحلة في الفحص
          if (invoiceID != null && invoiceID != undefined) {
            // setShowFinalPopup(true);
          } else {
            //await callback();
          }
          setIsLoadingStatus(false);
        }
      }).catch(async error => {
        ////console.log('error CreateSadadCodeMT:', error)
        setIsLoadingStatus(false);
      });
    } catch (error) {
      ////console.log('error', error)
      setIsLoadingStatus(false);

    }
  }


  const handelGoCheckSms = async (applePayPram = false) => {

    // onSucess();
    // PayTabs();
    ////console.log("isLoading:", isLoading);
    ////console.log("sadadInfo:", sadadInfo);
    ////console.log("orderStatusCode:", orderStatusCode);
    ////console.log("paymentType:", paymentType);
    if (!isLoading) {


      if (sadadInfo?.invoiceID) {
        // setShowFinalPopup(true);
        toast.success(trans("new:a_payment_number_has_already_been_created"));
        return
      }

      if (!(jobCardInfo && jobCardInfo["mobileNo"] != "0")) {

        toast.success(trans("new:mobile_not_found"));
        return
      }

      if (!(jobCardAmounts && jobCardAmounts["numberNet"] != "0")) {

        toast.success(trans("new:The_amount_cannot_be_zero"));
        return
      }

      if (applePayPram == false && orderStatusCode == "Approved") {
        if (paymentType) {

          ////console.log("paymentType on click: ", paymentType);
          // setShowPopup(true); //todo: ---- ترجع نفس ما كانت
          onSucess(); //todo: -- تبع التحقق

          // if (paymentType == 5 || paymentType == 4) {
          //   setShowPopup(true); //todo: ---- ترجع نفس ما كانت
          // } else {
          //   onSucess(); //todo: -- تبع التحقق
          // }

        } else {
          toast.error(trans("new:please_define_pay_method"));

        }
      } else if (applePayPram == true && orderStatusCode == 'Approved') {
        onSucessApple();
      }


    }


  }


  // * Not Use
  // const FetchinvoiceIDApp = async () => {
  //   try {
  //     const Body = {
  //       "name": "Fetch_invoiceIDApp", //todo: 11
  //       "values": {
  //         "GUID": number
  //       },
  //     }
  //     await axios.request({
  //       url: config.baseURLSadad + 'func',
  //       data: Body, method: "POST", responseType: "json"
  //     })
  //         .then(async function (response) {
  //           ////console.log("setSadadInfo:", response?.data);
  //
  //
  //           try {
  //             var invoiceID = response.data[0].invoiceID.replaceAll('"', "");
  //             ////console.log("invoiceID:", invoiceID);
  //             if (invoiceID && parseInt(invoiceID)) {
  //               var datasadad = response.data[0];
  //               datasadad.invoiceID = invoiceID;
  //               setSadadInfo(datasadad);
  //             } else {
  //
  //               setSadadInfo(response?.data[0]);
  //             }
  //
  //
  //           } catch (error) {
  //             setSadadInfo(response?.data[0]);
  //             ////console.log("error invoiceID:", error);
  //           }
  //
  //           if (response.data[0].invoiceID != null && response.data[0].invoiceID != undefined) {
  //
  //             setShowFinalPopup(true);
  //           } else {
  //             await callback();
  //           }
  //
  //         })
  //         .catch(function (error) {
  //
  //           ////console.log(error);
  //         });
  //   } catch (error) {
  //
  //     ////console.log("error:", error);
  //   }
  // };

  //PaymentMAin
  // * Not Use
  // async function PayTabs() {
  //
  //   setIsLoading(true);
  //   try {
  //     var myHeaders = new Headers();
  //     myHeaders.append("Content-Type", "application/json");
  //     var raw = {
  //       "GUID": number,
  //       "Callback": window.location.origin + "/" + lang + "/jobcard/"
  //     };
  //     axios.request({
  //       baseURL: config.controllerUrl,
  //       url: "sadad/api/sadad/PayTabsMT",
  //       headers: myHeaders,
  //       data: raw, method: "POST", responseType: "json"
  //     }).then(response => {
  //           ////console.log('PayTabs respons:', response);
  //           try {
  //
  //             if (response.data.URL_Paytabs)
  //               window.location.href = response.data.URL_Paytabs;
  //             else {
  //               setIsLoading(false);
  //               toast.error(trans("error:unknown_failure"));
  //
  //             }
  //             // history.push(response.data.URL_Paytabs);
  //           } catch (error) {
  //             toast.error(trans("error:unknown_failure"));
  //           }
  //
  //
  //         }
  //     ).then((response) => {
  //       ////console.log('response2', response);
  //     }).catch(error => {
  //       ////console.log('erro PayTabs', error)
  //       setIsLoading(false);
  //       toast.error(trans("error:unknown_failure"));
  //
  //
  //     });
  //   } catch (error) {
  //     ////console.log('error PayTabs', error)
  //     setIsLoading(false);
  //     toast.error(trans("error:unknown_failure"));
  //
  //   }
  //
  //
  // }

  //PaymentMAin
  // * Not Use
  // async function Tamara() {
  //
  //   setIsLoading(true);
  //   try {
  //     var myHeaders = new Headers();
  //     myHeaders.append("Content-Type", "application/json");
  //     myHeaders.append("Authorization", "Bearer ");
  //     var raw = {
  //       "order_reference_id": "123456",
  //       "order_number": jobCardInfo["Reception Number"],
  //       "total_amount": {
  //         "amount": totalNet1,
  //         "currency": "SAR"
  //       },
  //       "description": "string",
  //       "country_code": "SA",
  //       "payment_type": "PAY_BY_INSTALMENTS",
  //       "instalments": null,
  //       "locale": "en_US",
  //       "items": [
  //         {
  //           "reference_id": "123456",
  //           "type": "Digital",
  //           "name": "Sanaa City",
  //           "sku": "SA-12436",
  //           "image_url": "https://www.example.com/product.jpg",
  //           "quantity": 1,
  //           "unit_price": {
  //             "amount": "100.00",
  //             "currency": "SAR"
  //           },
  //           "discount_amount": {
  //             "amount": totalDescount,
  //             "currency": "SAR"
  //           },
  //           "tax_amount": {
  //             "amount": "100.00",
  //             "currency": "SAR"
  //           },
  //           "total_amount": {
  //             "amount": "100.00",
  //             "currency": "SAR"
  //           }
  //         }
  //       ],
  //       "consumer": {
  //         "first_name": "Mona",
  //         "last_name": "Lisa",
  //         "phone_number": "502223333",
  //         "email": "user@example.com"
  //       },
  //       "billing_address": {
  //         "first_name": "Mona",
  //         "last_name": "Lisa",
  //         "line1": "3764 Al Urubah Rd",
  //         "line2": "string",
  //         "region": "As Sulimaniyah",
  //         "postal_code": "12345",
  //         "city": "Riyadh",
  //         "country_code": "SA",
  //         "phone_number": "502223333"
  //       },
  //       "shipping_address": {
  //         "first_name": "Mona",
  //         "last_name": "Lisa",
  //         "line1": "3764 Al Urubah Rd",
  //         "line2": "string",
  //         "region": "As Sulimaniyah",
  //         "postal_code": "12345",
  //         "city": "Riyadh",
  //         "country_code": "SA",
  //         "phone_number": "502223333"
  //       },
  //       "discount": {
  //         "name": "Christmas 2020",
  //         "amount": {
  //           "amount": "100.00",
  //           "currency": "SAR"
  //         }
  //       },
  //       "tax_amount": {
  //         "amount": "100.00",
  //         "currency": "SAR"
  //       },
  //       "shipping_amount": {
  //         "amount": "100.00",
  //         "currency": "SAR"
  //       },
  //       "merchant_url": {
  //         "success": "https://example.com/checkout/success",
  //         "failure": "https://example.com/checkout/failure",
  //         "cancel": "https://example.com/checkout/cancel",
  //         "notification": "https://example.com/payments/tamarapay"
  //       },
  //       "platform": "Magento",
  //       "is_mobile": false,
  //       "risk_assessment": {
  //         "customer_age": 22,
  //         "customer_dob": "31-01-2000",
  //         "customer_gender": "Male",
  //         "customer_nationality": "SA",
  //         "is_premium_customer": true,
  //         "is_existing_customer": true,
  //         "is_guest_user": true,
  //         "account_creation_date": "31-01-2019",
  //         "platform_account_creation_date": "string",
  //         "date_of_first_transaction": "31-01-2019",
  //         "is_card_on_file": true,
  //         "is_COD_customer": true,
  //         "has_delivered_order": true,
  //         "is_phone_verified": true,
  //         "is_fraudulent_customer": true,
  //         "total_ltv": 501.5,
  //         "total_order_count": 12,
  //         "order_amount_last3months": 301.5,
  //         "order_count_last3months": 2,
  //         "last_order_date": "31-01-2021",
  //         "last_order_amount": 301.5,
  //         "reward_program_enrolled": true,
  //         "reward_program_points": 300
  //       },
  //       "expires_in_minutes": 0,
  //       "additional_data": {
  //         "delivery_method": "home delivery",
  //         "pickup_store": "Store A",
  //         "store_code": "Store code A",
  //         "vendor_amount": 0,
  //         "merchant_settlement_amount": 0,
  //         "vendor_reference_code": "string"
  //       }
  //     };
  //     axios.request({
  //       baseURL: config.controllerUrl,
  //       url: "https://api.tamara.co/checkout",
  //       headers: myHeaders,
  //       data: raw, method: "POST", responseType: "json"
  //     }).then(response => {
  //           ////console.log('tamara respons:', response);
  //           try {
  //             window.location.href = response.data.checkout_url;
  //             // history.push(response.data.URL_Paytabs);
  //           } catch (error) {
  //             toast.error(trans("error:unknown_failure"));
  //           }
  //
  //
  //         }
  //     ).then((response) => {
  //       ////console.log('response2', response);
  //     }).catch(error => {
  //       ////console.log('erro PayTabs', error)
  //       setIsLoading(false);
  //       toast.error(trans("error:unknown_failure"));
  //
  //
  //     });
  //   } catch (error) {
  //     ////console.log('error PayTabs', error)
  //     setIsLoading(false);
  //     toast.error(trans("error:unknown_failure"));
  //
  //   }
  //
  //
  // }

  const updatePaymentMethod = async (PaymentType) => {
    setIsLoading(true);


    let listofGroup;

    entityGroups.map((item) => {

      if (item.Approved)
        listofGroup = listofGroup == undefined || listofGroup == null || listofGroup == ""
          ? item.GUID
          : listofGroup + "," + item.GUID;
    });
    ////console.log('<<<<<<<<<<< listofGroup >>>>>>>>>>>', listofGroup)
    try {
      setMessageError(null);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = {
        "paymentType": PaymentType,
        "GUID": number,
        "prudocts": listofGroup,
        // "prudocts": "0d99fc88-2842-4d92-b679-c63b7b7ec956",
        // "prudocts": ",0d99fc88-2842-4d92-b679-c63b7b7ec956,0d99fc88-2842-4d92-b679-c63b7b7ec956", //todo: نرجعها نفس ما كانت 
        "Callback": window.location.origin + "/" + lang + `/jobCard/${number}` // todo: نضيف المتغير من شان الرابط الي بايرجع 
      };
      await axios.request({
        baseURL: config.controllerUrl,
        url: "/sadad/api/sadad/SendApprovedPayment_JC",
        headers: myHeaders,
        data: raw, method: "POST", responseType: "json"
      })

        .then(async response => {
          ////console.log('Payment respons data:\n', response.data);

          if ((paymentType == 6) && (PaymentType == 'myFatoorah')) {
            try {
              if (response.data.URL_Paytabs != null)
                window.location.href = response.data.URL_Paytabs;

              else if (response.data.MessageError != null && response.data.URL_Paytabs == null) {
                toast.warn(response.data.MessageError.toString());
              } else {
                setIsLoading(false);
                toast.error(trans("error:error_url") + " " + trans("error:payTabs"));
                ////console.log(">>>>>>>>>> if", trans("error:unknown_failure"));
              }
            } catch (error) {
              toast.error(trans("error:unknown_failure"));
              ////console.log(">>>>>>>>>> catch 1", error, trans("error:unknown_failure"));
            }
          }
          else if ((paymentType == 1 || paymentType == 3) && (PaymentType == 'full' || PaymentType == 'partial')) {
            try {
              if (response.data.URL_Paytabs != null)
                window.location.href = response.data.URL_Paytabs;

              else if (response.data.MessageError != null && response.data.URL_Paytabs == null) {
                toast.warn(response.data.MessageError.toString());
              } else {
                setIsLoading(false);
                toast.error(trans("error:error_url") + " " + trans("error:payTabs"));
                ////console.log(">>>>>>>>>> if", trans("error:unknown_failure"));
              }
            } catch (error) {
              toast.error(trans("error:unknown_failure"));
              ////console.log(">>>>>>>>>> catch 1", error, trans("error:unknown_failure"));
            }
          } //todo : S_SADAD

          else if (PaymentType == 'tamara' && paymentType == 2) {
            try {
              if (response.status >= 200 && response.status <= 300) {
                ////console.log(`Status Payment Tamara:`, response.status);
                ////console.log(`Data Payment Tamara:\n`, response.data.url_payment);
                if (response.data.url_payment != null) {
                  window.location.href = response.data.url_payment;
                } else {
                  toast.error(trans("error:error_url") + ' ' + trans("error:tmara"));
                }
              }
              // else if(response.status >= 300 && response.status <= 400) {
              //   setIsLoading(false);
              //   toast.error(trans("error:unknown_failure") +' '+response.status);
              //   ////console.log(`Status Payment Tamara:`, response.status);
              //   ////console.log(`Status Payment Tamara:`, response);
              // }
              // else {
              //   setIsLoading(false);
              //   ////console.log(`Status Payment Tamara:`, response.status);
              //   ////console.log(`Response Payment Tamara:\n`, response);
              // }
            } catch (ex) {
              toast.error(trans("error:not_completed") + ' ' + trans("error:tmara"));
              ////console.log(`Error [Catch] in Payment Tamara: \n`, ex.toString());
            }
          } else if (PaymentType == 'tabby' && paymentType == 22) {
            try {
              if (response.status >= 200 && response.status <= 300) {
                ////console.log(`Status Payment Tamara:`, response.status);
                ////console.log(`Data Payment Tamara:\n`, response.data.url_payment);
                if (response.data.url_payment != null) {
                  window.location.href = response.data.url_payment;

                } else if (response.data.MessageError) {

                  setMessageError(response.data.MessageError);

                } else {
                  toast.error(trans("error:error_url") + ' ' + trans("error:tabby"));
                }
              }
              // else if(response.status >= 300 && response.status <= 400) {
              //   setIsLoading(false);
              //   toast.error(trans("error:unknown_failure") +' '+response.status);
              //   ////console.log(`Status Payment Tamara:`, response.status);
              //   ////console.log(`Status Payment Tamara:`, response);
              // }
              // else {
              //   setIsLoading(false);
              //   ////console.log(`Status Payment Tamara:`, response.status);
              //   ////console.log(`Response Payment Tamara:\n`, response);
              // }
            } catch (ex) {
              toast.error(trans("error:not_completed") + ' ' + trans("error:tabby"));
              ////console.log(`Error [Catch] in Payment Tamara: \n`, ex.toString());
            }
          } else if (PaymentType == 'sadad' && paymentType == 5) {
            try {
              if (response.status >= 200 && response.status <= 300) {
                ////console.log(`Status Payment SDAD:`, response.status);
                ////console.log(`Data Payment SDAD:\n`, response.data.url_payment);
                if (response.data.url_payment != null) {
                  window.location.href = response.data.url_payment;
                } else {
                  toast.error(trans("error:error_occurred_executing") + ' ' + trans("error:sdad"));
                }
              }
              // else if(response.status >= 300 && response.status <= 400) {
              //   setIsLoading(false);
              //   toast.error(trans("error:unknown_failure") +' '+response.status);
              //   ////console.log(`Status Payment SDAD:`, response.status);
              //   ////console.log(`Response Payment SDAD:`, response);
              // }
              // else {
              //   setIsLoading(false);
              //   ////console.log(`Status Payment Tamara:`, response.status);
              //   ////console.log(`Response Payment Tamara:\n`, response);
              // }
            } catch (ex) {
              toast.error(trans("error:not_completed") + ' ' + trans("error:sdad"));
              ////console.log(`Error [Catch] in Payment Tamara: \n`, ex.toString());
            }
          } else if (PaymentType == 'uponReceipt') {
            try {
              if (response.status >= 200 && response.status <= 300) {
                ////console.log(`Status Payment else:`, response.status);
                ////console.log(`Data Payment else:\n`, response.data.url_payment);
                if (response.data.url_payment != null) {
                  window.location.href = response.data.url_payment;
                } else {
                  //   payment_upon_receipt
                  toast.error(trans("error:payment_upon_receipt"));
                }

                // window.location.href = 'http://localhost:3000/ar/jobCard/4955DB63-2E40-439A-A899-112D753E1766?PaymentMethod=PaymentWhenRecieving&PaymentType=Cash'
              }
              // else if(response.status >= 300 && response.status <= 400) {
              //   setIsLoading(false);
              //   toast.error(trans("error:unknown_failure") +' '+response.status);
              //   ////console.log(`Status Payment Full:`, response.status);
              //   ////console.log(`Response Payment Full:`, response);
              // }
              // else {
              //   setIsLoading(false);
              //   ////console.log(`Status Payment Full:`, response.status);
              //   ////console.log(`Response Payment Full:\n`, response);
              // }
            } catch (ex) {
              toast.error(trans("error:not_completed"));
              ////console.log(`Error [Catch] in Payment Full: \n`, ex.toString());
            }
            // window.location.reload(true);
          } else {
            let url = '';
            try {
              if (response.status >= 200 && response.status <= 300) {
                ////console.log(`else:`, response.status);
                ////console.log(`else:\n`, response.data.URL_Paytabs);
                if (response.data.URL_Paytabs != null || response.data.url_paymen != null) {
                  url = response.data.URL_Paytabs ?? response.data.url_paymen
                  window.location.href = url;
                } else {
                  toast.warn("URL:" + response.data.MessageError.toString());
                }
              }
            } catch (ex) {
              console.info(ex);
            }
          }

          setIsLoading(false);
        })
        .catch(function (error) {
          toast.error(trans("error:error_occurred_executing") + ' ' + error.toString());
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
      toast.error(trans("error:not_completed") + ' ' + error.toString());
      ////console.log("error:", error);
    }

  }

  const funCaptureAPaymentTamara = async (orderId) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    var raw = {
      "orderId": orderId,
      "GUID": number,
    };
    try {
      await axios.request({
        baseURL: config.controllerUrl,
        url: "/sadad/api/sadad/SendAuthoriseAndCuptureAnOrderTamara",
        headers: myHeaders,
        data: raw, method: "POST", responseType: "json"
      })
        .then(async response => {
          ////console.log('Capture APayment Tamara:\n', response);

          try {
            if (response.status >= 200 && response.status <= 300) {
              ////console.log(`Status Payment Full:`, response.status);
              ////console.log(`Data Payment Full:\n`, response.data.url_payment);
              ////console.log(`Data Payment Full:\n`, response.data.Error_messages);
              // !! window.location.href = response.data.url_payment;
            } else if (response.status >= 300 && response.status <= 400) {
              setIsLoading(false);
              toast.error(trans("error:unknown_failure") + ' ' + response.status);
              ////console.log(`Status Payment Full:`, response.status);
              ////console.log(`Response Payment Full:`, response);
            } else {
              setIsLoading(false);
              ////console.log(`Status Payment Full:`, response.status);
              ////console.log(`Response Payment Full:\n`, response);
            }
          } catch (ex) {
            toast.error(trans("error:unknown_failure") + ' ' + response.status);
            ////console.log(`Error [Catch] in Payment Tamara: \n`, ex.toString());
          }
        })
        .catch(function (error) {
          setIsLoading(false);
          ////console.log("error:", error);
        })
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      ////console.log("error:", error);
    }
  }

  const funCaptureAPaymentTabby = async () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    var raw = {
      "GUID": number,
    };
    try {
      await axios.request({
        baseURL: config.controllerUrl,
        url: "/sadad/api/sadad/SendTabbyCaptureJobCard",
        headers: myHeaders,
        data: raw, method: "POST", responseType: "json"
      })
        .then(async response => {
          ////console.log('Capture APayment Tamara:\n', response);
          try {
            if (response.status >= 200 && response.status <= 300 && response?.data?.Status == 'success') {

              setShowFinalPopup(true);
            } else if (response.status >= 300 && response.status <= 400) {
              setIsLoading(false);
              toast.error(trans("error:unknown_failure") + ' ' + response.status);
              ////console.log(`Status Payment Full:`, response.status);
              ////console.log(`Response Payment Full:`, response);
            } else {
              setIsLoading(false);
              ////console.log(`Status Payment Full:`, response.status);
              ////console.log(`Response Payment Full:\n`, response);
            }
          } catch (ex) {
            toast.error(trans("error:unknown_failure") + ' ' + response.status);
            ////console.log(`Error [Catch] in Payment Tamara: \n`, ex.toString());
          }
        })
        .catch(function (error) {
          setIsLoading(false);
          ////console.log("error:", error);
        })
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      ////console.log("error:", error);
    }
  }
  const SiteSendSdadCodeFormAppFunction = async (sadad, mobile) => {

    try {
      axios.request({
        url: config.controllerUrl + 'api/JobCard/SendSadadCode',
        data: { to: "966" + mobile, body: sadad }, method: "POST", responseType: "json"
      })
        .then(async function (response) {
          ////console.log("Fetch_DataSalesOrderApp:", response);

        })
        .catch(function (error) {
          ////console.log(error);
        });
    } catch (error) {
      ////console.log("error:", error);
    }

  }

  async function PaymentStatus() {
    //
    setIsLoadingStatus(true);
    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = {

        "GUID": number
      };
      await axios.request({
        baseURL: config.controllerUrl,
        url: "sadad/api/sadad/PaymentStatusMT",
        headers: myHeaders,
        data: raw, method: "POST", responseType: "json"
      }).then(async response => {
        ////console.log('PaymentStatus respons:', response.data);
        try {
          // if (response.data.SadadNumber != null || response?.data.SadadNumber != undefined) {
          //   var invoiceID = response?.data.SadadNumber.replaceAll('"', "");
          //   if (invoiceID && parseInt(invoiceID)) {
          //     var datasadad = response.data;
          //     datasadad.SadadNumber = invoiceID;
          //     setSadadInfo(datasadad);
          //
          //   } else {
          //     setSadadInfo(response?.data);
          //   }
          // }

          if (response.status >= 200 && response.status <= 299) {
            if (response?.data && response?.data.status == 0) {
              ////console.log('SadadNumber respons.data.status:', response.data.status);

              setIsPayed(response?.data.status);

              await getInfoAdditionalsLines();

              if (response?.data.PaymentMethodID == 'Sadad') {

                var invoiceID = response.data.SadadNumber.replaceAll('"', "");
                try {
                  if (invoiceID && parseInt(invoiceID)) {
                    var datasadad = response.data;
                    datasadad.SadadNumber = invoiceID;
                    setSadadInfo(datasadad);
                  } else {
                    setSadadInfo(response?.data);
                  }
                } catch (error) {
                  ////console.log("statuse 200 catch error", error);
                  setSadadInfo(response.data);
                  ////console.log("error invoiceID:", error);
                }
                //! اهمم مرحلة في الفحص
                if (invoiceID != null && invoiceID != undefined) {
                  // setShowFinalPopup(true);
                } else {
                  ////console.log("await callback()");
                  // await callback();
                }
                setIsLoadingStatus(false);
              }

              // else if(response.data.PaymentMethodID == 'PayTabs'){
              //   setShowFinalPopup(true);
              // }
              // else if(response.data.PaymentMethodID == ''){
              //
              // }

              // else {
              //   setShowFinalPopup(true);
              // }

              // if(response.data.SadadNumber != null || response.data.SadadNumber != undefined){
              //   ////console.log('SadadNumber respons.data.SadadNumber:', response.data.SadadNumber);
              //   setSadadInfo(parseInt(response.data.SadadNumber));

              // setShowFinalPopup(true);
            }
          }
          setIsLoadingStatus(false);
        } catch (error) {
          // setSadadInfo(response.data);
          ////console.log("error invoiceID:", error);
        }
        //! اهمم مرحلة في الفحص 
        if (invoiceID !== null && invoiceID !== undefined) {

          // setShowFinalPopup(true);

          await callback();
        } else {
          await callback();
        }


        setIsLoadingStatus(false);
      }
      ).catch(async error => {
        ////console.log('error PaymentStatus:', error)
        ////console.log('after FetchinvoiceIDApp');


        if (orderStatusCode == "Confirmd") {
          // setShowFinalPopup(true);
        } else
          await callback();

        setIsLoadingStatus(false);
      });
    } catch (error) {
      ////console.log('error', error);
      await callback();
      setIsLoadingStatus(false);

    }
  }

  const onSucessApple = async () => {

    if (!isLoading) {
      setShowPopup(false);
      await updatePaymentMethod("full");
    }
  }
  const onSucess = async () => {

    if (!isLoading) {
      setShowPopup(false);

      // const isLagout = window.confirm(trans("new:are_you_sure_you_have_completed_the_payment_process"));
      ////console.log("paymentType:", paymentType);

      if (paymentType == 1) {
        ////console.log("paymentType: ", 1, "full");
        await updatePaymentMethod("full");
      } else if (paymentType == 2) {
        ////console.log("paymentType: ", 2, "tamara");
        await updatePaymentMethod("tamara");
      } else if (paymentType == 22) {
        ////console.log("paymentType: ", 2, "tamara");
        await updatePaymentMethod("tabby");
      } else if (paymentType == 3) {
        ////console.log("paymentType: ", 3, "partial");
        await updatePaymentMethod("partial");
      } else if (paymentType == 5) {
        ////console.log("paymentType: ", 5, "sadad");// SADAD
        await updatePaymentMethod("sadad");
      }
      else if (paymentType == 6) {
        ////console.log("paymentType: ", 6, "myfatoorah");// SADAD
        await updatePaymentMethod("myFatoorah");
      } else {
        ////console.log("paymentType: ", 0, "uponReceipt");
        await updatePaymentMethod("uponReceipt");
      }


    }
  }

  const showPanelInfo = (currentIndexPanel) => {
    if (currentIndexPanel != indexPanel) {
      setIndexPanel(currentIndexPanel)
      setShowPanel(true)
    } else {
      setIndexPanel(currentIndexPanel)
      setShowPanel(!showPanel)
    }
  }

  const formatDateTime = useCallback((date, currentformat = null) => {
    try {
      if (date) {
        let dateNow = new Date(date)
        var formatDate;

        if (currentformat) {

          formatDate = currentformat;
        } else {
          formatDate = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
          }

        }


        if (lang.language === 'en') {
          return dateNow.toLocaleDateString('en-US', formatDate)
        } else {
          return dateNow.toLocaleDateString('en-US', formatDate)
        }
      } else {
        return date
      }
    } catch (error) {
      ////console.log(error)
      return date
    }
  }, [])

  const checkCallbackPaytabs = async (paymentMethodCallback, paymentTypeCallback) => {

    console.warn(" paymentMethodCallback >>>>>>>>>>>>>>>>>>>>>>>", paymentMethodCallback);
    console.warn(" paymentTypeCallback >>>>>>>>>>>>>>>>>>>>>>>>>", paymentTypeCallback);

    if (paymentMethodCallback != null && paymentTypeCallback != null) {

      if (paymentMethodCallback == 'myFatoorah' && paymentTypeCallback == 'full') {
        await PaymentMyFatoorahStatusFully();

      }
      else if (paymentMethodCallback == 'paytabs' && paymentTypeCallback == 'full') {
        await PaymentPaytabsStatusFully();

      } else if (paymentMethodCallback == 'paytabs' && paymentTypeCallback == 'partial') {
        await paymentPaytabsStatusPartially();
      } else if (paymentMethodCallback == 'sadad' && paymentTypeCallback == 'Fully') {
        await CreateSadadCodeMT();
      } else {
        ////console.log("ELSE...");
      }

    }
  }


  useEffect(() => {
    setCheckedState1(new Array(entityGroups.length).fill(false));
    // setCheck(true);
    // onRun();

    ////console.log(process.env.REACT_APP_UNSPLASH_URL);


  }, [entityGroups]);


  useEffect(() => {

    FetchDataOrder();

    // * يتم قراية الحالة من الرابط بعد القراءة من الرابط الراجع من تمارا
    const paymentStatus = new URL(window.location.href).searchParams.get("paymentStatus");
    const orderId = new URL(window.location.href).searchParams.get("orderId");

    const paymentMethodCallback = new URL(window.location.href).searchParams.get("PaymentMethod");
    const paymentTypeCallback = new URL(window.location.href).searchParams.get("PaymentType");

    checkCallbackPaytabs(paymentMethodCallback, paymentTypeCallback);


    if (paymentStatus) {
      console.warn(" paymentStatus >>>>>>>>>>>>>>>>>>>>>>>", paymentStatus);
      console.warn(" paymentStatus >>>>>>>>>>>>>>>>>>>>>>>", orderId);
    }

    if (paymentStatus == 'Error') {
      console.warn(" paymentStatus >>>>>>>>>>>>>>Error>>>>>>>>>>>>>>>", paymentStatus);
      console.warn(" orderId >>>>>>>>>>>>>>>>>>>>Error>>>>>>>>>>>>>>>", orderId);
      // toast.success(trans("messages:copied_successfully"));
      toast.warning(trans(lang == 'ar'
        ? "ليس لديك رصيد كافي لاكمال عملية الدفع"
        : "You do not have enough balance to complete the payment"));
    }
    if (paymentMethodCallback == 'Tabby') {
      funCaptureAPaymentTabby();
    }
    if (paymentStatus == 'approved' && paymentMethodCallback == 'Tamara') {
      console.warn(" orderId >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>", orderId);
      funCaptureAPaymentTamara(orderId);
      setShowFinalPopup(true);
    }
    // * ----------------

    // CreateSadadCodeMT(); // * اجهز الكويري استرنق 
  }, []);

  const [list, setList] = useState([]);
  const [checkCustomer, setCheckCustomer] = useState(false);
  const [checkTamarClose, setCheckTamarClose] = useState(false);

  //   // * GetCenterInfo
  async function GetCenterInfo(dateRec) {
    ////console.log("Get CenterInfo Reception Number Start: ", dateRec);

    try {
      await axios.request({
        url: config.controllerUrl + 'api/JobCard/GetCenterInfo',
        data: { guid: dateRec }, method: "POST", responseType: "json"
      })
        .then(async function (response) {
          //setIsLoading(false);
          ////console.log("GetCenterInfo Reception status: ", response.status);

          if (response.status >= 200 && response.status <= 300) {
            ////console.log("GetCenterInfo Reception data: ", response.data);
            if (response.data != null) {
              setCinderInfo(response?.data[0]);
            }
          }
        })
        .catch(function (error) {
          toast.error(trans("error:error_get_info") + ' ' + trans("error:info_center") + ' ' + error.toString());
          ////console.log("GetCenterInfo: ", error);
        });

    } catch (ex) {
      toast.error(trans("error:error_get_info") + trans("error:info_center") + ' ' + ex.toString());
      ////console.log("Catch Error GetCenterInfo: ", ex)
    }
  }

  // * funcCheckcustomer
  async function funcCheckcustomer(dateRec) {
    ////console.log("func Check customer Start: ", dateRec);

    try {
      await axios.request({
        url: config.controllerUrl + 'api/JobCard/CheckCustomer',
        data: { guid: dateRec }, method: "POST", responseType: "json"
      })
        .then(async function (response) {
          ////console.log("func Check Customer status: ", response.status);

          if (response.status >= 200 && response.status <= 300) {
            ////console.log("funcCheckcustomer data: ", response.data);
            if (response.data != null && response?.data[0] != null && response?.data[0]['CheckCustomer'] != null) {
              if (response?.data[0]['CheckCustomer'] == 0 && response?.data[0]['CheckCustomer'] == false) {
                setCheckCustomer(false);
              } else if (response?.data[0]['CheckCustomer'] == 1 && response?.data[0]['CheckCustomer'] == true) {
                setCheckCustomer(true);
              } else {
                setCheckCustomer(response?.data[0]['CheckCustomer']);
              }
            }
          }
        })
        .catch(function (error) {
          ////console.log("GetCenterInfo: ", error);
        });

    } catch (ex) {
      ////console.log("Catch Error GetCenterInfo: ", ex)
    }
  }


  // * GetTamaraStatusFlag
  async function GetTamaraStatus(Guid) {
    ////console.log("func Check GetTamaraStatusFlag Start: ", Guid);

    try {
      await axios.request({
        url: config.controllerUrl + 'api/JobCard/GetTamaraStatus',
        data: { guid: Guid }, method: "POST", responseType: "json"
      })
        .then(async function (response) {
          ////console.log("func Get GetTamaraStatusFlag: ", response.status);

          if (response.status >= 200 && response.status <= 300) {
            ////console.log("Get TamaraStatusFlag data: ", response.data);
            if (response.data != null && response?.data[0] != null && response?.data[0]['TamarClose'] != null) {

              if (response?.data[0]['TamarClose'] == 0 && response?.data[0]['TamarClose'] == false) {
                setCheckTamarClose(false);
              } else if (response?.data[0]['TamarClose'] == 1 && response?.data[0]['TamarClose'] == true) {
                setCheckTamarClose(true);
              } else {
                setCheckTamarClose(response?.data[0]['TamarClose']);
              }
            }
          }
        })
        .catch(function (error) {
          ////console.log("GetCenterInfo: ", error);
        });

    } catch (ex) {
      ////console.log("Catch Error GetCenterInfo: ", ex)
    }
  }

  const callback = useCallback(async () => {

    // onRun();
    setIsLoadingStatus(true)


    // try {
    //   const Body = {
    //     "name": "fetch_termsSO",
    //     "values": {
    //       "GUID": number
    //     },
    //   }
    //   axios.request({
    //     url: config.baseURLSadad + 'func',
    //     data: Body, method: "POST", responseType: "json"
    //   })
    //       .then(function (response) {
    //         ////console.log("fetch_termsSalesOrders:", response);
    //         setTermsSalesOrders(response.data);
    //
    //       })
    //       .catch(function (error) {
    //         ////console.log(error);
    //       });
    // } catch (error) {
    //   ////console.log("error:", error);
    // }


    try {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = {

        "GUID": number
      };
      axios.request({
        baseURL: config.controllerUrl,
        url: "/sadad/api/sadad/JobCardInfoSummary",
        headers: myHeaders,
        data: raw, method: "POST", responseType: "json"
      })
        .then(await function (response) {
          ////console.log('JobCardInfoSummary respons:', response.data);
          setJobCardInfoSummary(response.data);

          setGroups(response.data.groupList);
          // setJobCardAmounts(response.data.netTotal);
          setEntityGroups(response.data.jobCardRespons);
          setCheckedState1(new Array(entityGroups.length).fill(false));
          // setMntid(response.data.groups);
          //  ////console.log('MaintenanceOrderIDD respons:',response.data.MaintenanceOrderID);
          ////console.log('groups respons:', groups);
          // ////console.log('JobCardInfo oobj respons:',jobCardInfo);


          let numberNet = 0;
          let numberTotalBefore = 0;
          let numberDiscount = 0;
          let numberTax = 0;
          response.data.jobCardRespons.map((item, index) => {

            try {

              if (item.Approved) {
                numberNet = numberNet + item['Net Total'];
                numberTotalBefore = numberTotalBefore + item['Total Before Discount'];
                numberDiscount = numberDiscount + item['Discount'];
                numberTax = numberTax + item['Tax Amount'];
              }

            } catch (error) {

            }


          }
          );


          let amounts = {
            "numberNet": numberNet,
            "numberTotalBefore": numberTotalBefore,
            "numberDiscount": numberDiscount,
            "numberTax": numberTax
          }

          setJobCardAmounts(amounts);

        })
        .catch(function (error) {
          toast.error(trans("error:error_get_info") + trans("error:info_page") + ' ' + error.toString());
          ////console.log("JobCardInfoOils", error);
        });

    } catch (error) {
      toast.error(trans("error:error_get_info") + trans("error:info_page"));
      ////console.log("JobCardInfoOils", error);
    }

  }, []);

  const [check, setCheck] = useState(false);

  const popupSectionCallback = useCallback((orderStatusCode) => {

    //todo: ------------
    ////console.log("popupSectionCallback:", orderStatusCode)
    ////console.log(" sadadInfo?.invoiceIDhhh:", sadadInfo?.SadadNumber)
    let fragment = <></>;
    switch (orderStatusCode) {
      case "Approved":
        fragment =
          jobCardInfo?.MaintenanceOrderID &&
          <>

            {

              jobCardInfo?.MaintenanceOrderID &&
              <div className="cart-finalized-code"

                onClick={() => {

                  navigator.clipboard.writeText(jobCardInfo && jobCardInfo?.MaintenanceOrderID ? jobCardInfo?.MaintenanceOrderID : "");
                  toast.success(trans("messages:copied_successfully"));
                }}
              >
                <span
                  className="text-34 font-bold text-white mx-2"> {trans("jobCard:agreement_number")}</span>
                <code
                  className="text-white text-30">{jobCardInfo && jobCardInfo?.MaintenanceOrderID ? jobCardInfo?.MaintenanceOrderID : ""}</code>
                <img src="/assets/icons/copy.svg" alt='copy' />
              </div>
            }


            {
              sadadInfo?.invoiceID &&
              <div className="cart-finalized-code"

                onClick={() => {

                  navigator.clipboard.writeText(sadadInfo?.invoiceID ? sadadInfo?.invoiceID : "");
                  toast.success(trans("messages:copied_successfully"));
                }}
              >
                {/* <span className="text-34 font-bold text-gray mx-2"> {trans("new:sadad")}</span> */}
                <code
                  className="text-white text-30">{sadadInfo?.invoiceID ? sadadInfo?.invoiceID : ""}</code>
                <img src="/assets/icons/copy.svg" alt='copy' />
              </div>
            }
          </>

        break;

      case "Finance":
        fragment =
          <div className="flex flex-row justify-center">
            <span className="text-34 font-bold text-gray mx-2"> {trans("new:sales_order_number")}</span>
            <span
              className="text-34 font-bold text-gray mx-2">{jobCardInfo && jobCardInfo?.MaintenanceOrderID}</span>
          </div>
        break;

      case "Cash By Branch":
        fragment =
          <>
            <div className="flex flex-row justify-center">
              <span className="text-34 font-bold text-gray mx-2"> {trans("new:sales_order_number")}</span>
              <span
                className="text-34 font-bold text-gray mx-2">{jobCardInfo && jobCardInfo?.MaintenanceOrderID}</span>
            </div>
            <div className="flex flex-row justify-center mb-10">
              <span className="text-34 font-bold text-gray mx-2">{trans("new:message_By_Branch")}</span>
            </div>
          </>
        break;

      case "Canceled":
        fragment =
          <div className="flex flex-row justify-center mb-10">
            <span
              className="text-34 font-bold text-gray mx-2">{trans("new:agreement_link_is_cancelled")}</span>
          </div>
        break;
      case "notCorrect":
        fragment =
          <div className="flex flex-row justify-center mb-10">
            <span
              className="text-34 font-bold text-gray mx-2">{trans("new:agreement_status_is_invalid")}</span>
          </div>
        break;
      case "notFound":
        fragment =
          <div className="flex flex-row justify-center mb-10">
            <span
              className="text-34 font-bold text-gray mx-2">{trans("new:agreement_link_is_incorrect")}</span>
          </div>
        break;
      case "expired":
        fragment =
          <div className="flex flex-row justify-center mb-10">
            <span
              className="text-34 font-bold text-gray mx-2">{trans("new:agreement_link_has_expired")}</span>
          </div>
        break;
    }

    ////console.log(" fragment", fragment)


    return fragment

  }, [orderStatusCode, sadadInfo]);

  // الاشياء الاضافية ()
  const getInfoAdditionalsLines = async function () {
    // await checkCalculatorAdditional();
    try {
      await axios.request({
        url: config.controllerUrl + 'api/JobCard/GetInfoAdditionalsLines',
        data: { guid: number }, method: "POST", responseType: "json"
      })
        .then(async function (response) {
          ////console.log("getInfoAdditionalsLines status: ", response.status);
          if (response.status >= 200 && response.status <= 300) {
            ////console.log("getInfoAdditionalsLines data: ", response.data);
            if (response?.data.length && response?.data.length > 0) {
              ////console.log("response?.data.length: ", response?.data.length);
              await getInfoAdditionalsHeader()

              setAdditionalList(response?.data);
              ////console.log("setAdditionalList.length: ", additionalList.length);

              var list = [];
              var list2 = [];

              response?.data.map((item, index) => {
                ////console.log("additionalList.item: ", JSON.stringify(item), "  ", index);
                ////console.log("setGroupsAdditionalList.length: ", setGroupsAdditionalList.length);

                //(lang == 'ar'? item.GroupAr : item.GroupEn);
                if (!list2.includes(item.Group)) {
                  list = [...list, {
                    "group": item.Group,
                    "descAdditional": (lang == 'ar' ? item.GroupAr : item.GroupEn)
                  }]

                  list2 = [...list2, item.Group]
                }
              })

              setGroupsAdditionalList(list);
            }
          } else if (response.status == 400) {
            ////console.log("setGroupsAdditionalList: ", 400);
          }
        })
        .catch(function (error) {
          //toast.error(trans("error:error_get_info") + error.toString());
          ////console.log("setGroupsAdditionalList: ", error);
        })
    } catch (ex) {
      ////console.log("setGroupsAdditionalList.Catch: ", ex);
    }
  }

  // getInfoAdditionalsHeader
  const getInfoAdditionalsHeader = async function () {
    try {
      await axios.request({
        url: config.controllerUrl + 'api/JobCard/GetInfoAdditionalsHeader',
        data: { guid: number }, method: "POST", responseType: "json"
      })
        .then(async function (response) {
          ////console.log("getInfoAdditionalsHeader status: ", response.status);
          if (response.status >= 200 && response.status <= 300) {
            ////console.log("getInfoAdditionalsHeader data: ", response.data[0]);
            ////console.log("getInfoAdditionalsHeader.response?.data.length: ", response?.data.length);
            if (response?.data && response?.data[0]) {
              ////console.log("getInfoAdditionalsHeader.response?.data.length: ", response?.data.length);

              ////console.log("getInfoAdditionalsHeader.length: ", JSON.stringify(infoAdditionalHeader));
              setInfoAdditionalHeader(response?.data[0]);

              // var list = [];
              //
              // response?.data.map((item, index) => {
              //     ////console.log("additionalList.item: ", JSON.stringify(item), "  ", index);
              //     ////console.log("setGroupsAdditionalList.length: ", setGroupsAdditionalList.length);
              //
              //     //(lang == 'ar'? item.GroupAr : item.GroupEn);
              //     list = [...list, {
              //         "group": item.Group,
              //         "descAdditional": (lang == 'ar' ? item.GroupAr : item.GroupEn)
              //     }]
              // })

              // setGroupsAdditionalList(list);
            }
          }
        })
        .catch(function (error) {
          toast.error(trans("error:error_get_info") + error.toString());
          ////console.log("getInfoAdditionalsHeader.catch: ", error);
        });
    } catch (ex) {
      ////console.log("getInfoAdditionalsHeader.Catch: ", ex);
    }

  }

  const checkCalculatorAdditional = async (checked = false) => {
    try {
      let obTotal = {};

      if (checked == true) {

        obTotal = {
          "netTotal": infoAdditionalHeader.Remaining + jobCardAmounts["numberNet"],
          "numberTotalBefore": infoAdditionalHeader.NetTotalAfterPay, //+ jobCardAmounts["numberTotalBefore"] ,
          "totalTax": infoAdditionalHeader.TotalTaxAfterPay, //+ jobCardAmounts["numberTax"],
          "discountTotal": infoAdditionalHeader.DiscountTotalAfterPay,// + jobCardAmounts["numberDiscount"],
          "paidAmount": infoAdditionalHeader.PaidAmount,
          "remaining": infoAdditionalHeader.Remaining
        };
      } else { //3728
        obTotal = {
          "netTotal": jobCardAmounts["numberNet"],
          "numberTotalBefore": jobCardAmounts["numberTotalBefore"],
          "totalTax": jobCardAmounts["numberTax"],
          "discountTotal": jobCardAmounts["numberDiscount"],
          "paidAmount": infoAdditionalHeader.PaidAmount,
          "remaining": 0
        };
      }

      ////console.log("obTotal: ", obTotal);
      setTotalAfterAdditional(obTotal);

    } catch (ex) {
      ////console.log(ex);
    }
  }

  // 

  useEffect(() => {
    if (jobCardAmounts && jobCardAmounts["numberTotalBefore"]) {
      checkCalculatorAdditional(false);
    }
    console.info("checkCalculatorAdditional: >>>>>>", checkTamarClose)
  }, [jobCardAmounts]);


  useEffect(() => {

    console.info("mmm>>>>>>", checkTamarClose)
  }, [checkTamarClose]);


  return (
    isLoadingStatus ? (

      // <Loading />

      <>


        <Skeleton count={1} borderRadius={"1rem"} width={"100%"} height={"10rem"}
          containerClassName={"my-5"} className={"flex my-5"} inline={false} />

        <Skeleton count={1} borderRadius={"0 0 5rem 5rem"} width={"100%"} height={"80rem"}
          containerClassName={"my-5 cart-item-radius"} className={"flex my-5 cart-item-radius"}
          inline={false} />


        <Skeleton count={5} borderRadius={"1rem"} width={"100%"} height={"13rem"}
          containerClassName={"my-5"} className={"flex my-5"} inline={false} />


        <Skeleton count={2} borderRadius={"1rem"} width={"70%"} height={"5rem"}
          containerClassName={"my-5"} className={"flex my-5"} inline={false} />
        <Skeleton count={3} borderRadius={"1rem"} width={"90%"} height={"5rem"}
          containerClassName={"my-5"} className={"flex my-5"} inline={false} />
        <Skeleton count={2} borderRadius={"1rem"} width={"70%"} height={"5rem"}
          containerClassName={"my-5"} className={"flex my-5"} inline={false} />
        <Skeleton count={3} borderRadius={"1rem"} width={"90%"} height={"5rem"}
          containerClassName={"my-5"} className={"flex my-5"} inline={false} />


        <Skeleton count={2} borderRadius={"2rem"} width={"50%"} height={"15rem"}
          containerClassName={"flex flex-row nice-gap-2rem my-20"}
          className={"flex flex-row nice-gap-2rem my-20"} inline={true} />
      </>


    ) : (
      <div className=" unselectable ">
        {/* start navbar */}
        {/* <Navbar title={trans('jobCard:fix_agreement')}/> */}
        {/* end navbar */}

        <div className=" p-10 bg-black text-white">
          <div className="sales-header">
            <img src="/assets/logo/HassanJ-LOGO_white.svg" alt='discount' className="" />

            <h2 className="text-40 py-5 text-white text-center font-bold nice-apply-theme text-capitalize">{trans('jobCard:fix_agreement')}</h2>

            <div className={"change-lang text-bold text-24"}
              onClick={() => {
                // i18next.changeLanguage(trans("mobileCommon:changeLangCode")).then((r) => {
                // });
                //
                var bb = (window.location.pathname.includes("/en") || window.location.pathname.includes("/ar")) ? window.location.href.replace(/en|ar/, trans("mobileCommon:changeLangCode"))
                  : window.location.origin + "/" + trans("mobileCommon:changeLangCode") + window.location.pathname;
                ////console.log("......:", bb)
                window.location = bb;
              }}>{trans("mobileCommon:changeLang")}
              {/* <img src="/assets/icons/globle.svg" alt="change language" /> */}

            </div>
          </div>
        </div>


        <div className="nice-container flex flex-col nice-gap-1rem cart-item-radius bg-white">
          <div className="flex flex-row nice-gap-1rem mt-40">
            <span className="text-30 text-bold text-nowrap text-capitalize">
              {trans('jobCard:agreement_number')}:
            </span>
            <span
              className="text-30 text-bold">{jobCardInfo != null ? jobCardInfo["MaintenanceOrderID"] : ''}</span>
          </div>

          <div className="flex flex-row nice-gap-1rem">
            <span className="text-30 text-nowrap text-capitalize">
              {trans('jobCard:date_time')}:
            </span>
            <span className="text-30 language-en">
              {jobCardInfo != null ? formatDateTime(jobCardInfo["Receipt Date"]) : ''}
            </span>
          </div>

          <div className="flex flex-row nice-gap-1rem">
            <span className="text-30 text-nowrap text-capitalize">
              {trans('jobCard:the_date_time_of_the_promised_delivery')}:
            </span>
            <span className="text-30 language-en">
              {
                (jobCardInfo != null && jobCardInfo["Date and time of delivery"] != null)
                  ? formatDateTime(jobCardInfo["Date and time of delivery"])
                  : ''
              }
            </span>
          </div>

          <div className="flex flex-row nice-gap-1rem">
            <span className="text-30 text-nowrap text-capitalize">
              {trans('jobCard:reception_engineer')}:
            </span>
            <span className="text-30 " dir="ltr">
              {
                jobCardInfo != null
                  ?
                  (
                    lang == 'en'
                      ? jobCardInfo["Reception Engineer"] ?? ''
                      : jobCardInfo["Reception Engineer Ar"] ?? ''
                  )
                  : ''
              }
            </span>
          </div>

          {
            (jobCardInfo && jobCardInfo["Reception Mobile"]) &&
            <div className="flex flex-row nice-gap-1rem">
              <span className="text-30 text-nowrap text-capitalize">
                {trans('new:mobile')}:
              </span>
              <span className="text-24 text-bold text-info-light language-en" dir="ltr">
                {(jobCardInfo && jobCardInfo["Reception Mobile"])
                  ? <a
                    className="text-30 text-bold text-info-light language-en border-line-b"
                    href={'tel:' + jobCardInfo["Reception Mobile"]}
                  >
                    {jobCardInfo["Reception Mobile"]}
                  </a>
                  : ""
                }
              </span>
            </div>

          }


          {showInfo
            ? (
              (additionalList.length > 0 && groupsAdditionalList.length > 0)
                ? <>
                  <div className="flex flex-row nice-gap-1rem mt-20">
                    <span className="text-40 text-bold text-nowrap text-capitalize text-underline">
                      {trans('jobCard:additional_requests')}{ }
                    </span>
                  </div>
                  {
                    groupsAdditionalList.map((item, index) => {
                      return (
                        <div key={index}>
                          {
                            <>
                              <br />
                              <br />
                              <br />
                            </>
                          }

                          <div className="flex flex-row nice-gap-1rem">
                            <div className="flex flex-row nice-gap-1rem width-p-50">
                              <span className="text-30 text-nowrap text-bold text-capitalize ">
                                {/* {trans('mobileCommon:service_no')} */}
                                {/*{lang == 'en' ? item : item.ProductGroup}*/}
                                {item.descAdditional}
                              </span>

                            </div>
                            <div className="flex flex-row nice-gap-1rem width-p-50">
                              <span className="text-30 text-nowrap text-capitalize center-item width-p-25">
                                {trans('jobCard:number')}
                              </span>

                              <span
                                className="text-30 text-nowrap text-capitalize center-item width-p-50">
                                {trans('jobCard:cost')}
                              </span>

                              <span
                                className="text-30 text-nowrap text-capitalize center-item width-p-25">
                                {trans('jobCard:agreement')}
                              </span>
                            </div>
                          </div>

                          {
                            additionalList.map((itemA, indexA) => {
                              if ((item && itemA) && item.group === itemA.Group) {
                                return (
                                  <div key={indexA + 1} className="my-10">
                                    <div className="flex flex-row nice-gap-1rem">

                                      <div
                                        className="flex flex-row nice-gap-1rem width-p-50">
                                        <span
                                          className="text-30 text-wrap text-capitalize flex-grow  height-5 text-capitalize">
                                          {"- " + (lang == 'en' ? itemA.OrderNameEn : itemA.OrderName)}
                                        </span>
                                      </div>

                                      <div
                                        className="flex flex-row nice-gap-1rem width-p-50">
                                        <span
                                          className="text-30 text-nowrap text-capitalize center-item width-p-25">
                                          {(itemA.Qty)}
                                        </span>
                                        <span
                                          className="text-30 text-nowrap text-capitalize center-item width-p-50">
                                          {
                                            checkCustomer && checkCustomer == true ? 0 :
                                              itemA["SalesPrice"] != null
                                                ? itemA["SalesPrice"].toFixed(2)
                                                : ''
                                          } {trans('new:rial')}
                                        </span>

                                        <span
                                          className="text-30 text-nowrap text-capitalize center-item width-p-25">
                                          {/*{itemA.Approved == false ? 0 : 9}*/}
                                          <input
                                            type={'checkbox'}
                                            id={`custom-checkbox2-${indexA}`}
                                            name={`custom-checkbox2-${itemA["SalesPrice"]}`}
                                            value={itemA["NetTotal"]}
                                            checked={true}
                                            // checked={(itemA["Approved"] && itemA["Approved"] == true) ? true : false}
                                            readOnly={true}
                                            disabled
                                            onChange={(e) => handleOnChange1(indexA, itemA.GUID, e.target.checked, itemA.Qty, itemA["SalesPrice"].toFixed(2))}
                                            className={"text-primary"}
                                          />
                                        </span>
                                      </div>

                                    </div>
                                  </div>
                                );
                              }
                            })
                          }
                          <div className="flex flex-row nice-gap-1rem my-10">
                            <div
                              className="flex flex-row nice-gap-1rem width-p-50"></div>
                            <div
                              className="flex flex-row nice-gap-1rem width-p-50 border-gray-t"></div>
                          </div>
                        </div>
                      );
                    })
                  }
                </>

                : <>
                  <div className="flex flex-row nice-gap-1rem mt-20">
                    <span className="text-40 text-bold text-nowrap text-capitalize text-underline">
                      {trans('jobCard:guest_requests')}
                    </span>
                  </div>


                  {groups.map((item1, index22) => {
                    return (

                      <div key={index22}>

                        {
                          // index22 == 0 ? "" :
                          <>
                            <br />
                            <br />
                            <br />
                          </>

                        }

                        <div className="flex flex-row nice-gap-1rem">
                          <div className="flex flex-row nice-gap-1rem width-p-50">
                            <span className="text-30 text-nowrap text-bold text-capitalize ">
                              {/* {trans('mobileCommon:service_no')} */}
                              {lang == 'en' ? item1.group : item1.groupAr}
                            </span>
                          </div>
                          <div className="flex flex-row nice-gap-1rem width-p-50">
                            <span className="text-30 text-nowrap text-capitalize center-item width-p-25">
                              {trans('jobCard:number')}
                            </span>

                            <span
                              className="text-30 text-nowrap text-capitalize center-item width-p-50">
                              {trans('jobCard:cost')}
                            </span>

                            <span
                              className="text-30 text-nowrap text-capitalize center-item width-p-25">
                              {trans('jobCard:agreement')}
                            </span>
                          </div>
                        </div>


                        {

                          entityGroups.map((item, index) => {
                            // ////console.log("item:", item.Group);
                            //  int sum=sum + item["Net Total"]
                            // setTotal(total + item["Net Total"])
                            // ////console.log("item1:", total);
                            if ((item?.Group && item1?.group) && JSON.stringify(item.Group) === JSON.stringify(item1.group)) {
                              return (

                                <div key={index + 1} className="my-10">
                                  <div className="flex flex-row nice-gap-1rem">

                                    <div
                                      className="flex flex-row nice-gap-1rem width-p-50">
                                      <span
                                        className="text-30 text-wrap text-capitalize flex-grow  height-5 text-capitalize">
                                        {"- " + (lang == 'en' ? item["Product"] : item["Product Ar"])}
                                      </span>
                                    </div>


                                    <div
                                      className="flex flex-row nice-gap-1rem width-p-50">
                                      <span
                                        className="text-30 text-nowrap text-capitalize center-item width-p-25">
                                        {(item.Qty)}
                                      </span>
                                      <span
                                        className="text-30 text-nowrap text-capitalize center-item width-p-50">
                                        {
                                          checkCustomer && checkCustomer == true ? 0 :
                                            item["Net Total Excluding Tax"] != null
                                              ? item["Net Total Excluding Tax"].toFixed(2)
                                              : ''
                                        } {trans('new:rial')}
                                      </span>

                                      <span
                                        className="text-30 text-nowrap text-capitalize center-item width-p-25">
                                        <input
                                          type={'checkbox'}
                                          id={`custom-checkbox2-${index}`}
                                          name={`custom-checkbox2-${item["Net Total Excluding Tax"]}`}
                                          value={item["Net Total Excluding Tax"]}
                                          checked={(item["Approved"] && item["Approved"] == true) ? true : false}
                                          readOnly={true}
                                          disabled
                                          onChange={(e) => handleOnChange1(index, item.GUID, e.target.checked, item.Qty, item["Net Total Excluding Tax"].toFixed(2))}
                                          className={"text-primary"}
                                        />
                                      </span>
                                    </div>
                                    <br />
                                  </div>
                                  <br />
                                </div>


                              )
                            }
                            ;
                          })
                        }


                        {
                          entityGroups?.length > 0 &&

                          <div className="">
                            <div className="flex flex-row nice-gap-1rem">

                              <div className="flex flex-row nice-gap-1rem width-p-50">
                                <span className="text-30 text-wrap text-capitalize flex-grow  height-5 text-capitalize">

                                </span>
                              </div>


                              <div
                                className="flex flex-row nice-gap-1rem width-p-50 border-gray-t py-5">
                                <span className="text-30 text-nowrap text-capitalize center-item width-p-25">

                                </span>

                                <span
                                  className="text-30 text-nowrap text-capitalize center-item width-p-50">{trans('jobCard:select_all1')}{" " + trans('jobCard:select_all2')}</span>


                                <span
                                  className="text-30 text-nowrap text-capitalize center-item width-p-25 ">
                                  <input
                                    type={'checkbox'}
                                    id={'select-all-' + item1.group}
                                    checked={true}
                                    //checked={(item1["Approved"] && item1["Approved"] == true) ? true : false}
                                    onChange={(e) => {
                                      handleOnChange1Groups(item1.group, e.target.checked)
                                    }}
                                    className={"text-primary"}
                                    disabled
                                  />
                                </span>
                              </div>
                              <br />
                            </div>
                            <br />
                          </div>


                        }

                      </div>
                    )
                  })
                  }

                </>
            )
            : (
              <>
                <div className="flex flex-row nice-gap-1rem">
                  <span
                    className="text-40 text-bold text-nowrap text-capitalize text-underline"></span>
                </div>
              </>
            )
          }

          {

            agreementShow && <Link to={'#'} className="flex flex-col items-center  mt-5 p-10"

              onClick={() => {
                setShowInfo(!showInfo);
              }}
            >


              {
                (showInfo == true) ? (

                  <>
                    <span
                      className="text-20 my-10 text-capitalize">{trans("mobileCommon:request_guest_hidden")}</span>
                    <img src="/assets/icons/arrow-down.svg" className="object-contain rotate-180" />
                    <img src="/assets/icons/arrow-down.svg" className="object-contain rotate-180" />
                  </>

                )

                  :
                  (

                    <>
                      <span
                        className="text-20 my-10 text-capitalize">{trans("mobileCommon:request_guest_show")}</span>
                      <img src="/assets/icons/arrow-down.svg" className="object-contain" />
                      <img src="/assets/icons/arrow-down.svg" className="object-contain" />
                    </>
                  )

              }
            </Link>
          }

          <br />
          <br />


        </div>

        {/* end notes */}

        <div className="carOverview-page-body ">
          {
            (additionalList.length > 0 && groupsAdditionalList.length > 0)
              ?
              <div className="panel-section panel-white">
                <div className={`panel-content ${(indexPanel == '7000') & showPanel
                  ? 'show-panel-info' : ''}`
                }>
                  <div
                    className="panel-content-top nice-container"
                    onClick={(e) => showPanelInfo('7000')}
                  >
                    <h1 className="text-40 text-super-gray  text-capitalize">
                      {' '}
                      {trans('jobCard:basic_requests')}
                    </h1>

                    <img src="/assets/icons/arrow.svg" />
                  </div>

                  <div className="panel-content-body">
                    <div className="nice-container flex flex-col nice-gap-1rem ">
                      {
                        groups.map((item1, index22) => {
                          return (
                            <div key={index22}>
                              {
                                <>
                                  <br />
                                  <br />
                                  <br />
                                </>
                              }

                              <div className="flex flex-row nice-gap-1rem">
                                <div className="flex flex-row nice-gap-1rem width-p-50">
                                  <span className="text-30 text-nowrap text-bold text-capitalize ">
                                    {/* {trans('mobileCommon:service_no')} */}
                                    {lang == 'en' ? item1.group : item1.groupAr}
                                  </span>
                                </div>
                                <div className="flex flex-row nice-gap-1rem width-p-50">
                                  <span className="text-30 text-nowrap text-capitalize center-item width-p-25">
                                    {trans('jobCard:number')}
                                  </span>

                                  <span
                                    className="text-30 text-nowrap text-capitalize center-item width-p-50">
                                    {trans('jobCard:cost')}
                                  </span>

                                  <span
                                    className="text-30 text-nowrap text-capitalize center-item width-p-25">
                                    {trans('jobCard:agreement')}
                                  </span>
                                </div>
                              </div>

                              {

                                entityGroups.map((item, index) => {
                                  // ////console.log("item:", item.Group);
                                  //  int sum=sum + item["Net Total"]
                                  // setTotal(total + item["Net Total"])
                                  // ////console.log("item1:", total);
                                  if ((item?.Group && item1?.group) && JSON.stringify(item.Group) === JSON.stringify(item1.group)) {
                                    return (

                                      <div key={index + 1} className="my-10">
                                        <div
                                          className="flex flex-row nice-gap-1rem">

                                          <div
                                            className="flex flex-row nice-gap-1rem width-p-50">
                                            <span
                                              className="text-30 text-wrap text-capitalize flex-grow  height-5 text-capitalize">
                                              {"- " + (lang == 'en' ? item["Product"] : item["Product Ar"])}
                                            </span>
                                          </div>


                                          <div
                                            className="flex flex-row nice-gap-1rem width-p-50">
                                            <span
                                              className="text-30 text-nowrap text-capitalize center-item width-p-25">
                                              {(item.Qty)}
                                            </span>
                                            <span
                                              className="text-30 text-nowrap text-capitalize center-item width-p-50">
                                              {
                                                checkCustomer && checkCustomer == true ? 0 :
                                                  item["Net Total Excluding Tax"] != null
                                                    ? item["Net Total Excluding Tax"].toFixed(2)
                                                    : ''
                                              } {trans('new:rial')}
                                            </span>

                                            <span
                                              className="text-30 text-nowrap text-capitalize center-item width-p-25">
                                              <input
                                                type={'checkbox'}
                                                id={`custom-checkbox2-${index}`}
                                                name={`custom-checkbox2-${item["Net Total Excluding Tax"]}`}
                                                value={item["Net Total Excluding Tax"]}
                                                checked={(item["Approved"] && item["Approved"] == true) ? true : false}
                                                readOnly={true}
                                                disabled
                                                onChange={(e) => handleOnChange1(index, item.GUID, e.target.checked, item.Qty, item["Net Total Excluding Tax"].toFixed(2))}
                                                className={"text-primary"}
                                              />
                                            </span>
                                          </div>
                                          <br />
                                        </div>
                                        <br />
                                      </div>


                                    )
                                  }
                                })
                              }


                              {
                                entityGroups?.length > 0 &&

                                <div className="">
                                  <div className="flex flex-row nice-gap-1rem">

                                    <div
                                      className="flex flex-row nice-gap-1rem width-p-50">
                                      <span className="text-30 text-wrap text-capitalize flex-grow  height-5 text-capitalize">

                                      </span>
                                    </div>


                                    <div
                                      className="flex flex-row nice-gap-1rem width-p-50 border-gray-t py-5">
                                      <span
                                        className="text-30 text-nowrap text-capitalize center-item width-p-25">

                                      </span>
                                      <span
                                        className="text-30 text-nowrap text-capitalize center-item width-p-50">
                                        {/*{trans('jobCard:select_all1')}{" " + trans('jobCard:select_all2')}*/}
                                      </span>


                                      <span
                                        className="text-30 text-nowrap text-capitalize center-item width-p-25 ">
                                        {/*<input*/}
                                        {/*    type={'checkbox'}*/}
                                        {/*    id={'select-all-' + item1.group}*/}
                                        {/*    checked={true}*/}
                                        {/*    //checked={(item1["Approved"] && item1["Approved"] == true) ? true : false}*/}
                                        {/*    onChange={(e) => { handleOnChange1Groups(item1.group, e.target.checked) }}*/}
                                        {/*    className={"text-primary"}*/}
                                        {/*    disabled*/}
                                        {/*/>*/}
                                      </span>
                                    </div>
                                  </div>
                                </div>


                              }

                            </div>
                          )
                        })
                      }
                    </div>
                  </div>

                </div>
              </div>
              :
              <></>
          }

          {/* start guest info */}
          <div className="panel-section panel-white">
            <div
              className={`panel-content  ${(indexPanel == '1000') & showPanel ? 'show-panel-info' : ''
                }`}
            >
              <div
                className="panel-content-top nice-container"
                onClick={(e) => showPanelInfo('1000')}
              >
                <h1 className="text-40 text-super-gray  text-capitalize">
                  {' '}
                  {trans('jobCard:guest_information')}
                </h1>

                <img src="/assets/icons/arrow.svg" />
              </div>

              {/* <div className="panel-content-body">
                <div className="nice-container flex flex-col nice-gap-1rem ">
                  <div className="flex flex-row nice-gap-1rem ">
                    <div className={`flex flex-col nice-gap-1rem ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r mr-10 pr-10'} `}>
                      <span className="text-30 text-bold text-nowrap height-5 text-capitalize">
                        {trans('jobCard:vehicle_owner')}:
                      </span>
                      <span className="text-30 text-bold text-nowrap height-5 text-capitalize">
                        {trans('new:mobile')}:
                      </span>
                      <span className="text-30 text-bold text-nowrap height-5 text-capitalize">
                        {trans('jobCard:Identity_or_residence')}:
                      </span>
                      <span className="text-30 text-bold text-nowrap height-5 text-capitalize">
                        {trans('jobCard:who_brought_the_vehicle')}:
                      </span>
                    </div>

                    <div className="flex flex-col nice-gap-1rem">
                      <span className="text-30 height-5">
                        {jobCardInfo != null ? lang == 'en' ? jobCardInfo["Vehicle Owner"] : jobCardInfo["Vehicle Owner Ar"] : ''}

                      </span>
                      <span className="text-30 height-5 " dir="ltr">
                        {jobCardInfo != null ? jobCardInfo["mobileNo"] : ''}
                      </span>
                      <span className="text-30 height-5 " dir="ltr">
                        {jobCardInfo != null ? jobCardInfo["Personal Identification"] : ''}
                      </span>
                      <span className="text-30 height-5 " dir="ltr">
                        {jobCardInfo != null ? jobCardInfo["Who brought the vehicle"] : ''}

                      </span>
                    </div>
                  </div>
                </div>
              </div> */}


              <div className="panel-content-body">

                <div className="nice-container flex flex-col nice-gap-1rem ">
                  <Table striped bordered hover size="sm" className='border-spacing-1'>
                    <thead>
                      <tr>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>


                      <tr className="">
                        <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                          {trans('jobCard:vehicle_owner')}:
                        </td>
                        <td className="text-30  px-10" dir="ltr">
                          {jobCardInfo != null ? lang == 'en' ? jobCardInfo["Vehicle Owner"] : jobCardInfo["Vehicle Owner Ar"] : ''}
                        </td>
                      </tr>

                      <tr className="">
                        <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                          {trans('new:mobile')}:
                        </td>
                        <td className="text-30  px-10" dir="ltr">
                          {jobCardInfo != null ? jobCardInfo["mobileNo"] : ''}
                        </td>
                      </tr>

                      <tr className="">
                        <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                          {trans('jobCard:Identity_or_residence')}:
                        </td>
                        <td className="text-30  px-10" dir="ltr">
                          {jobCardInfo != null ? jobCardInfo["Personal Identification"] : ''}
                        </td>
                      </tr>


                      {
                        (jobCardInfo && jobCardInfo["Who brought the vehicle"]) &&
                        <tr className="">
                          <td className={`  text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                            {trans('jobCard:who_brought_the_vehicle')}:
                          </td>
                          <td className="text-30  px-10" dir="ltr">
                            {jobCardInfo != null ? jobCardInfo["Who brought the vehicle"] : ''}
                          </td>
                        </tr>

                      }
                      {
                        (jobCardInfo && jobCardInfo["Who brought the vehicle Mobile"]) &&
                        <tr className="">
                          <td className={`  text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                            {trans('new:mobile')}:
                          </td>
                          <td className="text-30  px-10" dir="ltr">
                            {jobCardInfo != null ? jobCardInfo["Who brought the vehicle Mobile"] : ''}
                          </td>
                        </tr>

                      }

                    </tbody>
                  </Table>
                </div>
              </div>

            </div>
          </div>
          {/* end guest info */}

          {/* start service info */}
          <div className="panel-section panel-white">
            <div
              className={`panel-content  ${(indexPanel == '2000') & showPanel ? 'show-panel-info' : ''
                }`}
            >
              <div
                className="panel-content-top nice-container"
                onClick={(e) => showPanelInfo('2000')}
              >
                <h1 className="text-40 text-super-gray  text-capitalize">
                  {' '}
                  {trans('jobCard:service_information')}
                </h1>

                <img src="/assets/icons/arrow.svg" />
              </div>

              {/* <div className="panel-content-body">
                <div className="nice-container flex flex-col nice-gap-1rem pt-10 pb-10">
                  <div className="flex flex-row  ">
                    <div className={`flex flex-col nice-gap-1rem ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r mr-10 pr-10'} `}>
                      <span className="text-30 text-bold height-5 text-capitalize">
                        {trans('jobCard:payment_method')}:
                      </span>

                      <span className="text-30 text-bold text-nowrap height-5 text-capitalize">
                        {trans('jobCard:service_type')}:
                      </span>
                      <span className="text-30 text-bold text-nowrap height-5 text-capitalize">
                        {trans('jobCard:repair_type')}:
                      </span>
                      <span className="text-30 text-bold text-nowrap height-5 text-capitalize">
                        {trans('jobCard:guest_type')}:
                      </span>
                      <span className="text-30 text-bold text-nowrap height-5 text-capitalize">
                        {trans('jobCard:hand_over_the_old_pieces')}:
                      </span>
                      <span className="text-30 text-bold text-nowrap height-5 text-capitalize">
                        {trans('jobCard:vehicle_transportation_service')}:
                      </span>
                      <span className="text-30 text-bold text-nowrap height-5 text-capitalize">
                        {trans('jobCard:notes_last_visit')}:
                      </span>
                    </div>

                    <div className="flex flex-col  nice-gap-1rem ">
                      <span className="text-30 height-5 text-nowrap">

                        {jobCardInfo != null ? lang == 'en' ? jobCardInfo["Payment Method"] : jobCardInfo["Payment Method Ar"] : ''}
                      </span>
                      <span className="text-30 height-5 text-nowrap" dir="ltr">

                        {jobCardInfo != null ? lang == 'en' ? jobCardInfo["Service Type"] : jobCardInfo["Service Type Ar"] : ''}
                      </span>
                      <span className="text-30 height-5 " dir="ltr">

                        {jobCardInfo != null ? lang == 'en' ? jobCardInfo["Repair Type"] : jobCardInfo["Repair Type Ar"] : ' . '}
                      </span>
                      <span className="text-30 height-5 " dir="ltr">
                        {jobCardInfo != null ? lang == 'en' ? jobCardInfo["Guest type"] : jobCardInfo["Guest type Ar"] : ''}

                      </span>
                      <span className="text-30 height-5 " dir="ltr">
                        {jobCardInfo != null ? lang == 'en' ? jobCardInfo["Retrun Old Parts"] : jobCardInfo["Retrun Old Parts Ar"] : ''}
                      </span>
                      <span className="text-30 height-5 " dir="ltr">

                        {jobCardInfo != null ? lang == 'en' ? jobCardInfo["Vehicle Transportation Service"] : jobCardInfo["Vehicle Transportation Service Ar"] : ''}
                      </span>
                      <span className="text-30 height-5 " dir="ltr">
                   
                        {jobCardInfo != null ? lang == 'en' ? jobCardInfo["Vehicle Transportation Service"] : jobCardInfo["Vehicle Transportation Service Ar"] : ''}
                      </span>
                    </div>
                  </div>
                </div>
              </div> */}


              <div className="panel-content-body">

                <div className="nice-container flex flex-col nice-gap-1rem ">
                  <Table bordered hover size="sm" striped="columns" className='border-spacing-1'>
                    <thead>
                      <tr>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                          {trans('jobCard:payment_method')}:
                        </td>
                        <td className="text-30  px-10" dir="ltr">
                          {jobCardInfo != null ? lang == 'en' ? jobCardInfo["Payment Method"] : jobCardInfo["Payment Method Ar"] : ''}
                        </td>
                      </tr>
                      <tr>
                        <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                          {trans('jobCard:service_type')}:
                        </td>
                        <td className="text-30  px-10" dir="ltr">
                          {jobCardInfo != null ? lang == 'en' ? jobCardInfo["Service Type"] : jobCardInfo["Service Type Ar"] : ''}

                        </td>
                      </tr>

                      <tr>
                        <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                          {trans('jobCard:repair_type')}:
                        </td>
                        <td className="text-30  px-10" dir="ltr">
                          {jobCardInfo != null ? lang == 'en' ? jobCardInfo["Repair Type"] : jobCardInfo["Repair Type Ar"] : ' . '}
                        </td>
                      </tr>


                      <tr>
                        <td className={`  text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                          {trans('jobCard:guest_type')}:
                        </td>
                        <td className="text-30  px-10" dir="ltr">
                          {jobCardInfo != null ? lang == 'en' ? jobCardInfo["Guest type"] : jobCardInfo["Guest type Ar"] : ''}
                        </td>
                      </tr>
                      <tr>
                        <td className={`  text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                          {trans('jobCard:hand_over_the_old_pieces')}:
                        </td>
                        <td className="text-30  px-10" dir="ltr">
                          {jobCardInfo != null ? lang == 'en' ? jobCardInfo["Retrun Old Parts"] : jobCardInfo["Retrun Old Parts Ar"] : ''}
                        </td>
                      </tr>
                      <tr>
                        <td className={`  text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                          {trans('jobCard:vehicle_transportation_service')}:
                        </td>
                        <td className="text-30  px-10" dir="ltr">
                          {jobCardInfo != null ? lang == 'en' ? jobCardInfo["Vehicle Transportation Service"] : jobCardInfo["Vehicle Transportation Service Ar"] : ''}
                        </td>
                      </tr>
                      <tr>
                        <td className={`  text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                          {trans('jobCard:notes_last_visit')}:
                        </td>
                        <td className="text-30  px-10" dir="ltr">
                          {jobCardInfo != null ? lang == 'en' ? jobCardInfo["Vehicle Transportation Service"] : jobCardInfo["Vehicle Transportation Service Ar"] : ''}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>


            </div>
          </div>
          {/* end service info */}

          {/* start vehicle info */}
          <div className="panel-section panel-white">
            <div
              className={`panel-content  ${(indexPanel == '3000') & showPanel ? 'show-panel-info' : ''
                }`}
            >
              <div
                className="panel-content-top nice-container"
                onClick={(e) => showPanelInfo('3000')}
              >
                <h1 className="text-40 text-super-gray  text-capitalize">
                  {' '}
                  {trans('jobCard:vehicle_information')}
                </h1>

                <img src="/assets/icons/arrow.svg" />
              </div>

              {/* <div className="panel-content-body">
                <div className="nice-container flex flex-col nice-gap-1rem ">
                  <div className="flex flex-row nice-gap-1rem ">
                    <div className={`flex flex-col nice-gap-1rem ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r mr-10 pr-10'} `}>
                      <span className="text-30 text-bold text-nowrap height-5 text-capitalize">
                        {trans('jobCard:brand_and_model')}:
                      </span>

                      <span className="text-30 text-bold text-nowrap height-5 text-capitalize">
                        {trans('jobCard:structure_number')}:
                      </span>
                      <span className="text-30 text-bold text-nowrap height-5 text-capitalize">
                        {trans('jobCard:plate_number_and_color')}:
                      </span>
                      <span className="text-30 text-bold text-nowrap height-5 text-capitalize">
                        {trans('jobCard:the_date_of_purchase')}:
                      </span>
                      <span className="text-30 text-bold text-nowrap height-5 text-capitalize">
                        {trans('jobCard:meter_reading')}:
                      </span>
                      <span className="text-30 text-bold text-nowrap height-5 text-capitalize">
                        {trans('jobCard:fuel_indicator')}:
                      </span>
                      <span className="text-30 text-bold text-nowrap height-5 text-capitalize">
                        {trans('jobCard:warning_lights')}:
                      </span>
                    </div>

                    <div className="flex flex-col nice-gap-1rem">
                      <span className="text-30 height-5">

                        {jobCardInfo != null ? lang == 'en' ? jobCardInfo["Brand"] : jobCardInfo["Brand Ar"] : ''} - {jobCardInfo != null ? jobCardInfo["Model"] : ''}
                      </span>
                      <span className="text-30 height-5 " dir="ltr">

                        {jobCardInfo != null ? jobCardInfo["Chassis number"] : ''}
                      </span>
                      <span className="text-30 height-5 " dir="ltr">

                        {jobCardInfo != null ? jobCardInfo["Plate Number"] : ''}
                      </span>
                      <span className="text-30 height-5 " dir="ltr">

                        {jobCardInfo != null ? formatDateTime(jobCardInfo["The date of purchase"], 'mm/dd/yy') : ''}
                      </span>
                      <span className="text-30 height-5 " dir="ltr">
                        {jobCardInfo != null ? jobCardInfo["meter reading"] : ''}
                      </span>


                      <span className="text-30 height-5 " dir="ltr">
                        {jobCardInfo != null ? jobCardInfo["fuel indicator"] : ''}
                      </span>
                      <span className="text-30 height-5 " dir="ltr">

                        {jobCardInfo != null ? lang == 'en' ? jobCardInfo["Warning bulbs"] : jobCardInfo["Warning bulbs Ar"] : ''}
                      </span>
                    </div>
                  </div>
                </div>
              </div> */}


              <div className="panel-content-body">

                <div className="nice-container flex flex-col nice-gap-1rem ">
                  <Table striped bordered hover size="sm" className='border-spacing-1'>
                    <thead>
                      <tr>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="">
                        <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                          {trans('jobCard:brand_and_model')}:
                        </td>
                        <td className="text-30  px-10" dir="ltr">
                          {jobCardInfo != null ? lang == 'en' ? jobCardInfo["Brand"] : jobCardInfo["Brand Ar"] : ''} - {jobCardInfo != null ? jobCardInfo["Model"] : ''}
                        </td>
                      </tr>
                      <tr className="">
                        <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                          {trans('jobCard:structure_number')}:
                        </td>
                        <td className="text-30  px-10" dir="ltr">
                          {jobCardInfo != null ? jobCardInfo["Chassis number"] : ''}
                        </td>
                      </tr>

                      <tr className="">
                        <td className={` text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                          {trans('jobCard:plate_number_and_color')}:
                        </td>
                        <td className="text-30  px-10" dir="ltr">
                          {jobCardInfo != null ? jobCardInfo["Plate Number"] : ''}
                        </td>
                      </tr>


                      <tr className="">
                        <td className={`  text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                          {trans('jobCard:the_date_of_purchase')}:
                        </td>
                        <td className="text-30  px-10" dir="ltr">
                          {jobCardInfo != null ? formatDateTime(jobCardInfo["The date of purchase"], 'mm/dd/yy') : ''}
                        </td>
                      </tr>


                      <tr className="">
                        <td className={`  text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                          {trans('jobCard:meter_reading')}:
                        </td>
                        <td className="text-30  px-10" dir="ltr">
                          {jobCardInfo != null ? jobCardInfo["meter reading"] : ''}
                        </td>
                      </tr>


                      <tr className="">
                        <td className={`  text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                          {trans('jobCard:fuel_indicator')}:
                        </td>
                        <td className="text-30  px-10" dir="ltr">
                          {jobCardInfo != null ? jobCardInfo["fuel indicator"] : ''}
                        </td>
                      </tr>


                      <tr className="">
                        <td className={`  text-30 text-bold text-nowrap  text-capitalize  ${lang == 'ar' ? 'border-l ml-10 pl-10' : 'border-r  mr-10 pr-10'} `}>
                          {trans('jobCard:warning_lights')}:
                        </td>
                        <td className="text-30  px-10" dir="ltr">
                          {jobCardInfo != null ? lang == 'en' ? jobCardInfo["Warning bulbs"] : jobCardInfo["Warning bulbs Ar"] : ''}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>


            </div>
          </div>
          {/* end vehicle info */}

          {/* start visual_inspection_of_the_vehicle */}
          <div className="panel-section panel-white">
            <div
              className={`panel-content  ${(indexPanel == '4000') & showPanel ? 'show-panel-info' : ''
                }`}
            >
              <div
                className="panel-content-top nice-container"
                onClick={(e) => showPanelInfo('4000')}
              >
                <h1 className="text-40 text-super-gray  text-capitalize">
                  {' '}
                  {trans('jobCard:visual_inspection_of_the_vehicle')}
                </h1>

                <img src="/assets/icons/arrow.svg" />
              </div>

              <div className="panel-content-body ">
                <div className=" flex flex-col nice-container nice-gap-1rem">
                  <div className="flex flex-col nice-gap-1rem ">
                    <div className="flex flex-row nice-gap-1rem mt-10">
                      <span className="text-30 text-bold  text-nowrap height-5 text-capitalize ">
                        {trans('jobCard:dent')}
                      </span>
                      <span
                        className="text-30 text-bold mr-10 text-nowrap height-5 text-capitalize">
                        {trans('jobCard:scratches')}
                      </span>
                      <span
                        className="text-30 text-bold mr-10 text-nowrap height-5 text-capitalize">
                        {trans('jobCard:rust')}
                      </span>
                      <span
                        className="text-30 text-bold mr-10 text-nowrap height-5 text-capitalize">
                        {trans('jobCard:fractures')}
                      </span>
                      <span
                        className="text-30 text-bold mr-10 text-nowrap height-5 text-capitalize">
                        {trans('jobCard:peel')}
                      </span>
                    </div>
                    <div className="flex flex-row height-50  pr-40  pl-40">

                      {jobCardInfo?.CarImage
                        ? <img
                          src={'data:image/png;base64,' + jobCardInfo['CarImage'] || jobCardInfo['carImage']}
                          alt="drow" className='draw-image' />
                        : <img src="/assets/test/draw.png" alt="/assets/images/default.png" />
                      }

                    </div>
                    <div className="flex flex-row ">
                      <span className="text-30 text-bold text-nowrap height-5 text-capitalize text-underline">
                        {trans('jobCard:tools')}
                      </span>
                    </div>

                    <div className="flex flex-row nice-gap-1rem ">
                      <div className="flex flex-nowrap nice-gap-1rem">
                        <div className="flex flex-col nice-gap-1rem ">
                          <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                            {trans('jobCard:floor_rug')}
                          </span>
                          <span
                            className="text-24 text-bold text-nowrap height-5 text-capitalize">
                            {trans('jobCard:extinguisher')}
                          </span>
                          <span
                            className="text-24 text-bold text-nowrap height-5 text-capitalize">
                            {trans('jobCard:lighter')}
                          </span>
                          <span
                            className="text-24 text-bold text-nowrap height-5 text-capitalize">
                            {trans('jobCard:spare_tire')}
                          </span>
                          <span
                            className="text-24 text-bold text-nowrap height-5 text-capitalize">
                            {trans('jobCard:car_lift')}
                          </span>
                        </div>
                        {
                          jobCardInfo &&

                          <div className="flex flex-col nice-gap-1rem ">
                            <span className="text-24 text-bold text-nowrap  text-capitalize">
                              <input type={'checkbox'} readOnly={true}
                                checked={(jobCardInfo && jobCardInfo["FloorMat"] && jobCardInfo["FloorMat"] == true) ? true : false} />
                            </span>
                            <span
                              className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              <input type={'checkbox'} readOnly={true}
                                checked={(jobCardInfo && jobCardInfo["AshTry"] && jobCardInfo["AshTry"] == true) ? true : false} />
                            </span>
                            <span
                              className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              <input type={'checkbox'} readOnly={true}
                                checked={(jobCardInfo && jobCardInfo["Lighter"] && jobCardInfo["Lighter"] == true) ? true : false} />
                            </span>
                            <span
                              className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              <input type={'checkbox'} readOnly={true}
                                checked={(jobCardInfo && jobCardInfo["SpareTire"] && jobCardInfo["SpareTire"] == true) ? true : false} />
                            </span>
                            <span
                              className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              <input type={'checkbox'} readOnly={true}
                                checked={(jobCardInfo && jobCardInfo["WhealJack"] && jobCardInfo["WhealJack"] == true) ? true : false} />
                            </span>
                          </div>

                        }

                      </div>

                      <div className="nice-gap-1rem"></div>
                      <div className="flex flex-row nice-gap-1rem">
                        <div className="flex flex-col nice-gap-1rem ">
                          <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                            {trans('jobCard:wheel_covers')}
                          </span>
                          <span
                            className="text-24 text-bold text-nowrap height-5 text-capitalize">
                            {trans('jobCard:toolbox')}
                          </span>
                          <span
                            className="text-24 text-bold text-nowrap height-5 text-capitalize">
                            {trans('jobCard:metal_wheel')}
                          </span>
                          <span
                            className="text-24 text-bold text-nowrap height-5 text-capitalize">
                            {trans('jobCard:metal_wheel_lock')}
                          </span>
                          <span
                            className="text-24 text-bold text-nowrap height-5 text-capitalize">
                            {trans('jobCard:first_aid_kit')}
                          </span>
                        </div>
                        {
                          jobCardInfo &&
                          <div className="flex flex-col nice-gap-1rem ">
                            <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              <input type={'checkbox'} readOnly={true}
                                checked={(jobCardInfo["WheelCaps"] && jobCardInfo["WheelCaps"] == true) ? true : false} />
                            </span>
                            <span
                              className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              <input type={'checkbox'} readOnly={true}
                                checked={(jobCardInfo["ToolBox"] && jobCardInfo["ToolBox"] == true) ? true : false} />
                            </span>
                            <span
                              className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              <input type={'checkbox'} readOnly={true}
                                checked={(jobCardInfo["AllyWheel"] && jobCardInfo["AllyWheel"] == true) ? true : false} />
                            </span>
                            <span
                              className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              <input type={'checkbox'} readOnly={true}
                                checked={(jobCardInfo["AllyWheelLock"] && jobCardInfo["AllyWheelLock"] == true) ? true : false} />
                            </span>
                            <span
                              className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              <input type={'checkbox'} readOnly={true}
                                checked={(jobCardInfo["FirstAidKit"] && jobCardInfo["FirstAidKit"] == true) ? true : false} />
                            </span>
                          </div>

                        }

                      </div>
                      <div className="nice-gap-1rem"></div>
                      <div className="flex flex-row nice-gap-1rem">
                        <div className="flex flex-col nice-gap-1rem ">
                          <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                            {trans('jobCard:remote')}
                          </span>
                          <span
                            className="text-24 text-bold text-nowrap height-5 text-capitalize">
                            {trans('jobCard:USB_storage_device')}
                          </span>
                          <span
                            className="text-24 text-bold text-nowrap height-5 text-capitalize">
                            {trans('jobCard:dial_screen')}
                          </span>
                          <span
                            className="text-24 text-bold text-nowrap height-5 text-capitalize">
                            {trans('jobCard:navigation_memory_card')}
                          </span>
                          <span
                            className="text-24 text-bold text-nowrap height-5 text-capitalize">
                            {trans('jobCard:air_compressor')}
                          </span>
                        </div>

                        {
                          jobCardInfo &&
                          <div className="flex flex-col nice-gap-1rem ">
                            <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              <input type={'checkbox'} readOnly={true}
                                checked={(jobCardInfo["SmartKeyRemote"] && jobCardInfo["SmartKeyRemote"] == true) ? true : false} />
                            </span>
                            <span
                              className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              <input type={'checkbox'} readOnly={true}
                                checked={(jobCardInfo["USBDevice"] && jobCardInfo["USBDevice"] == true) ? true : false} />
                            </span>
                            <span
                              className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              <input type={'checkbox'} readOnly={true}
                                checked={(jobCardInfo["DVDnavScreen"] && jobCardInfo["DVDnavScreen"] == true) ? true : false} />
                            </span>
                            <span
                              className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              <input type={'checkbox'} readOnly={true}
                                checked={(jobCardInfo["NavMemoryCard"] && jobCardInfo["NavMemoryCard"] == true) ? true : false} />
                            </span>
                            <span
                              className="text-24 text-bold text-nowrap height-5 text-capitalize">
                              <input type={'checkbox'} readOnly={true}
                                checked={(jobCardInfo["AirComprissor"] && jobCardInfo["AirComprissor"] == true) ? true : false} />
                            </span>
                          </div>

                        }

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="panel-section panel-white">
            <div
              className={`panel-content show-panel-info ${(indexPanel == '6000') & showPanel ? 'show-panel-info' : ''
                }`}
            >
              <div
                className="panel-content-top nice-container"
                onClick={(e) => showPanelInfo('6000')}
              >
                <h1 className="text-40   text-super-gray text-capitalize">
                  {' '}
                  {trans('new:center_information')}{' '}
                </h1>

                <img src="/assets/icons/arrow.svg" />
              </div>

              <div className="panel-content-body">
                <CenterInfo data={cinderInfo} />


              </div>
            </div>
          </div>
          {/* end center info */}
          <div className=" my-10">
            <div className="flex flex-col nice-gap-2rem">
              <div className="flex flex-row justify-between items-center nice-container">
                <h3 className="text-40 font-bold text-black"> {trans("new:pay_method")}</h3>

              </div>


              {
                platformTypes && platformTypes.includes("myfatoorah") &&
                <div className={"flex flex-row nice-gap-1rem   p-5 " + (paymentType == 6 ? "bg-gray-light " : "")}>
                  <label
                    className={" text-30 text-bold  flex flex-row nice-gap-1rem pr-10 pl-10  items-center"}>
                    <input type='radio' checked={paymentType == 6 ? true : false} name='paymentType'
                      onClick={() => {
                        setPaymentType(6);

                      }}

                      onChange={() => {


                      }}
                      id="primary"


                      disabled={sadadInfo?.invoiceID ? true : false}
                    />
                    {trans("new:pay_all")}

                  </label>
                  <div className="flex flex-row items-center  ">
                    <img className="cart-payment-icon object-contain"
                      src="/assets/icons/companies/master-card-3.png" alt={"master"} />
                    <img className="cart-payment-icon object-contain"
                      src="/assets/icons/companies/visa-3.png" alt={"visa"} />
                    <img className="cart-payment-icon object-contain"
                      src="/assets/icons/companies/mada-3.png" alt={"mada"} />
                    {/*<img className="cart-payment-icon object-contain" src={"/assets/icons/companies/SADAD-Logo.png"} alt={"SADAD"} />*/}
                  </div>

                </div>
              }


              {

                platformTypes && platformTypes.includes("payTabs") &&
                <div
                  className={"flex flex-row nice-gap-1rem   p-5 " + (paymentType == 1 ? "bg-gray-light " : "")}>
                  <label
                    className={" text-30 text-bold  flex flex-row nice-gap-1rem pr-10 pl-10  items-center"}>
                    <input type='radio' checked={paymentType == 1 ? true : false} name='paymentType'
                      onClick={() => {
                        setPaymentType(1);

                      }}

                      onChange={() => {


                      }}
                      id="primary"


                      disabled={sadadInfo?.invoiceID ? true : false}
                    />
                    {trans("new:pay_all")}

                  </label>
                  <div className="flex flex-row items-center  ">
                    <img className="cart-payment-icon object-contain"
                      src="/assets/icons/companies/master-card-3.png" alt={"master"} />
                    <img className="cart-payment-icon object-contain"
                      src="/assets/icons/companies/visa-3.png" alt={"visa"} />
                    <img className="cart-payment-icon object-contain"
                      src="/assets/icons/companies/mada-3.png" alt={"mada"} />
                    {/*<img className="cart-payment-icon object-contain" src={"/assets/icons/companies/SADAD-Logo.png"} alt={"SADAD"} />*/}
                  </div>

                </div>

              }

              {

                platformTypes && platformTypes.includes("sadad") &&
                <div
                  className={"flex flex-row nice-gap-1rem   p-5 " + (paymentType == 5 ? "bg-gray-light " : "")}>
                  <label
                    className={" text-30 text-bold  flex flex-row nice-gap-1rem pr-10 pl-10  items-center"}>
                    <input type='radio' checked={paymentType == 5 ? true : false} name='paymentType'
                      onClick={() => {
                        setPaymentType(5);

                      }}

                      onChange={() => {


                      }}
                      id="primary"


                      disabled={sadadInfo?.invoiceID ? true : false}
                    />
                    {trans("new:pay_all")}

                  </label>
                  <div className="flex flex-row items-center  ">
                    <img className="cart-payment-icon object-contain"
                      src={"/assets/icons/companies/SADAD-Logo.png"} alt={"SADAD"} />
                  </div>

                </div>
              }



              {
                platformTypes && platformTypes.includes("tamara") &&
                <div
                  className={"flex flex-col nice-gap-1rem  p-5 " + (paymentType == 2 ? "bg-gray-light my-10" : "")}>
                  <label
                    className={" text-30 text-bold  flex flex-row nice-gap-1rem pr-10 pl-10  items-center"}>
                    <input type='radio' checked={paymentType == 2 ? true : false} name='paymentType'
                      onClick={() => {

                        setPaymentType(2);
                      }}
                      onChange={() => {

                      }}

                      id="primary"
                      // disabled={sadadInfo?.sadadNumber ? true : false}
                      disabled={checkTamarClose === true ? true : false}
                    />

                    <div className="flex flex-row  ">
                      <img className="cart-payment-icon object-contain"
                        src={lang == 'ar'
                          ? "/assets/icons/companies/tamara/AR-tamara.svg"
                          : "/assets/icons/companies/tamara/En-tamara.svg"}
                        alt={""}
                      // onError={"/assets/icons/companies/tamara.jpeg"}
                      />
                    </div>

                    {trans("jobCard:byTamara")}


                  </label>
                  <label className={" text-30  flex flex-row  pr-20 pl-20"}>
                    {lang == 'ar'
                      ? trans("jobCard:byTamara3")
                      : trans("jobCard:byTamara3").charAt(0).toUpperCase()
                    }
                    {lang == 'ar' ? <></>
                      : <label
                        className="text-30  flex flex-row first-letter-lowercase">{trans("jobCard:byTamara3").slice(1)}</label>
                    }
                  </label>
                  <label className={" text-30  flex flex-row pr-20 pl-20 "}>
                    {lang == 'ar'
                      ? trans("jobCard:byTamara4")
                      : trans("jobCard:byTamara4").charAt(0).toUpperCase()
                    }
                    {lang == 'ar' ? <></>
                      : <label
                        className="text-30  flex flex-row first-letter-lowercase">{trans("jobCard:byTamara4").slice(1)}</label>
                    }
                  </label>
                </div>

              }
              {
                platformTypes && platformTypes.includes("tamara") &&
                <div
                  className={"flex flex-col nice-gap-1rem  p-5 " + (paymentType == 22 ? "bg-gray-light my-10" : "")}>
                  <label
                    className={" text-30 text-bold  flex flex-row nice-gap-1rem pr-10 pl-10  items-center"}>
                    <input type='radio' checked={paymentType == 22 ? true : false} name='paymentType'
                      onClick={() => {

                        setPaymentType(22);
                      }}
                      onChange={() => {

                      }}

                      id="primary"
                      // disabled={sadadInfo?.sadadNumber ? true : false}
                      disabled={checkTamarClose === true ? true : false}
                    />

                    <div className="flex flex-row  ">
                      <img className="cart-payment-icon object-contain"
                        src={lang == 'ar'
                          ? "/assets/icons/tabby.png"
                          : "/assets/icons/tabby.png"}
                        alt={""}
                      // onError={"/assets/icons/companies/tabby.jpeg"}
                      />
                    </div>

                    {lang=="ar"?"قسّمها على 4 دفعات ,بدون فوائد أو رسوم" :"Pay in 4. No interest, no fees"}


                  </label>
                  <div id="TabbyPromo"></div>

                  {
                    MessageError &&
                    <div className='language-en  nice-border text-bold flex border-danger flex-col nice-gap-1rem  p-10  my-10 text-danger text-20'
                      style={{ backgroundColor: "#ffe6e3" }}
                    >{MessageError}</div>
                  }

                </div>

              }
              {
                platformTypes && platformTypes.includes("payTabsPartial") &&
                <div
                  className={"flex flex-col nice-gap-1rem  p-5  " + (paymentType == 3 ? "bg-gray-light my-10" : "")}>
                  <label
                    className={" text-30 text-bold flex flex-wrap nice-gap-1rem pr-10 pl-20  items-center"}>
                    <input type='radio' checked={paymentType == 3 ? true : false} name='paymentType'
                      onClick={() => {

                        setPaymentType(3);
                      }}
                      onChange={() => {

                      }}
                      id="primary"
                      disabled={sadadInfo?.invoiceID ? true : false}
                    />
                    {trans("jobCard:minimum_payment")} {"  "} {" ("} {trans("jobCard:byTamara2")} {" )"} {trans("jobCard:remaining_upon_receipt")}
                    <div className="flex flex-row   pr-10">
                      <img className="cart-payment-icon object-contain"
                        src="/assets/icons/companies/master-card-3.png" alt={"master"} />
                      <img className="cart-payment-icon object-contain"
                        src="/assets/icons/companies/visa-3.png" alt={"visa"} />
                      <img className="cart-payment-icon object-contain"
                        src="/assets/icons/companies/mada-3.png" alt={"mada"} />
                      {/* <img className="cart-payment-icon object-contain" src={"/assets/icons/companies/SADAD-Logo.png"} alt={"SADAD"} /> */}
                    </div>
                  </label>
                </div>

              }



            </div>
          </div>

          <div className="flex flex-row nice-gap-1rem nice-container margin-vertical">
            <div
              className="text-30 mb-20"
              onClick={() => {
                console.info('termsSalesOrders: ', termsSalesOrders);
                if (termsSalesOrders.length != 0 && termsSalesOrders != "NOTDATA") {
                  setShowTermsPopup(true);
                }
              }}
            >
              {trans('mobileCommon:cart_agreement_part0')}&nbsp;
              <span className="text-info-light text-30 mx-1">
                {trans('mobileCommon:cart_agreement_part2')}
              </span>
              {trans('mobileCommon:cart_agreement_part3')}
            </div>
          </div>

          {(additionalList.length > 0 && infoAdditionalHeader)
            ? <div className="flex flex-row nice-gap-1rem nice-container my-10">

              <span className="text-30 text-super-gray text-capitalize flex">
                <span className="text-24 text-bold text-nowrap height-5 text-capitalize">
                  <input
                    value={1}
                    type={'checkbox'}
                    // readOnly={true}
                    // checked={
                    //
                    // }
                    onChange={async (event) => {
                      // if (event.target.checked)
                      await checkCalculatorAdditional(event.target.checked);
                      ////console.log("checkCalculatorAdditionalhhhhhhhhh", totalAfterAdditional.netTotal);
                    }}
                  />
                </span>

                <label
                  className="text-24 text-bold text-nowrap height-5 text-capitalize mx-8 my-5">
                  {trans('jobCard:remaining_main_task_card')}
                  <span className="text-24 text-primary mx-3">
                    {infoAdditionalHeader.Remaining + " " + trans('new:rial')}
                  </span>
                </label>

              </span>

              <span className="text-30 text-super-gray text-capitalize font-bold">

                {/*{checkCustomer == true ? 0 :*/}
                {/*    jobCardAmounts != null*/}
                {/*        ? jobCardAmounts["numberTotalBefore"].toFixed(2)*/}
                {/*        : ''*/}
                {/*} {trans('new:rial')}*/}
              </span>
            </div>
            : <></>
          }

          <div className="flex flex-row nice-gap-1rem nice-container">

            <span className="text-30 text-super-gray text-capitalize flex-grow">
              {trans('jobCard:estimated_repair_costs')}
            </span>

            {
              (additionalList.length > 0 && infoAdditionalHeader)
                ?
                <span className="text-30 text-super-gray text-capitalize font-bold">

                  {checkCustomer == true ? 0 :
                    jobCardAmounts != null && totalAfterAdditional["numberTotalBefore"]
                      ? totalAfterAdditional["numberTotalBefore"].toFixed(2)
                      : ''
                  } {trans('new:rial')}

                </span>
                : <span className="text-30 text-super-gray text-capitalize font-bold">

                  {checkCustomer == true ? 0 :
                    jobCardAmounts != null
                      ? jobCardAmounts["numberTotalBefore"].toFixed(2)
                      : ''
                  } {trans('new:rial')}

                </span>
            }
          </div>

          <div className="flex flex-row nice-gap-1rem nice-container">
            <span className="text-30 text-super-gray text-capitalize flex-grow">
              {trans('jobCard:discount')}
            </span>
            {
              (additionalList.length > 0 && infoAdditionalHeader)
                ?
                <span className="text-30 text-super-gray text-capitalize font-bold">
                  {
                    checkCustomer == true ? 0 :
                      totalAfterAdditional != null && totalAfterAdditional["discountTotal"] != null
                        ? totalAfterAdditional["discountTotal"].toFixed(2)
                        : ''
                  } {trans('new:rial')}
                </span>
                :
                <span className="text-30 text-super-gray text-capitalize font-bold">
                  {
                    checkCustomer == true ? 0 :
                      jobCardAmounts != null
                        ? jobCardAmounts["numberDiscount"].toFixed(2)
                        : ''
                  } {trans('new:rial')}
                </span>
            }
          </div>

          <div className="flex flex-row nice-gap-1rem nice-container">
            <span className="text-30 text-super-gray text-capitalize flex-grow">
              {trans('mobileCommon:tax')}
            </span>

            {
              (additionalList.length > 0 && infoAdditionalHeader)
                ? <span className="text-30 text-super-gray text-capitalize font-bold">
                  {
                    checkCustomer == true ? 0 :
                      totalAfterAdditional != null && totalAfterAdditional["totalTax"]
                        ? totalAfterAdditional["totalTax"].toFixed(2)
                        : ''
                  } {trans('new:rial')}
                </span>
                : <span className="text-30 text-super-gray text-capitalize font-bold">
                  {
                    checkCustomer == true ? 0 :
                      jobCardAmounts != null
                        ? jobCardAmounts["numberTax"].toFixed(2)
                        : ''
                  } {trans('new:rial')}
                </span>
            }
          </div>

          <div className="nice-container">
            <div className="border-line"></div>
          </div>

          {(additionalList.length > 0 && infoAdditionalHeader)
            ? <div className="flex flex-row nice-gap-1rem nice-container">

              <span className="text-30 text-super-gray text-capitalize flex-grow">
                {trans('jobCard:prepaid_amount')}
              </span>
              <span className="text-30 text-super-gray text-capitalize font-bold">

                {checkCustomer == true ? 0 :
                  infoAdditionalHeader != null && infoAdditionalHeader["PaidAmount"]
                    ? infoAdditionalHeader["PaidAmount"].toFixed(2)
                    : ''
                } {trans('new:rial')}
              </span>
            </div>
            : <></>
          }

          <div className="flex flex-row nice-gap-1rem nice-container">
            <span className="text-30 font-bold text-capitalize flex-grow">
              {trans('jobCard:estimated_total')}
            </span>

            <span className="text-30 cart-bill-row-item mx-2 margin-top">
              {
                checkCustomer == true ? "" : trans('jobCard:VAT_included')
              }
            </span>

            {
              (additionalList.length > 0 && infoAdditionalHeader)
                ? <span className={checkCustomer == true
                  ? "text-30 font-bold text-capitalize font-bold text-primary"
                  : "text-30 font-bold text-capitalize font-bold text-primary"}
                >
                  {checkCustomer == true ? trans("error:free") : jobCardAmounts != null
                    ? totalAfterAdditional && totalAfterAdditional["netTotal"]
                      ? totalAfterAdditional["netTotal"].toFixed(2)
                      : 0
                    : ''
                  } {checkCustomer == true ? "" : trans('new:rial')}
                </span>

                : <span className={checkCustomer == true
                  ? "text-30 font-bold text-capitalize font-bold text-primary"
                  : "text-30 font-bold text-capitalize font-bold text-primary"}
                >
                  {checkCustomer == true ? trans("error:free") : jobCardAmounts != null
                    ? jobCardAmounts["numberNet"].toFixed(2)
                    : ''
                  } {checkCustomer == true ? "" : trans('new:rial')}
                </span>
            }
          </div>

          {
            (additionalList.length > 0 && infoAdditionalHeader)
              ?
              <div className="nice-container">
                <div className="border-line"></div>
              </div>
              :
              <></>
          }

          {
            (additionalList.length > 0 && infoAdditionalHeader)
              ? <div className="flex flex-row nice-gap-1rem nice-container">

                <span className="text-30 text-super-gray text-capitalize flex-grow">
                  {trans('jobCard:amount_due_payment')}
                </span>
                <span className="text-30 text-super-gray text-capitalize font-bold">
                  {checkCustomer == true ? 0 :
                    infoAdditionalHeader != null && infoAdditionalHeader["Remaining"]
                      ? infoAdditionalHeader["Remaining"].toFixed(2)
                      : ''
                  } {trans('new:rial')}
                </span>
              </div>
              : <></>
          }


          {
            checkCustomer == true
              ? <div className="text-white text-20 basis-2/4 my-32 order-1" dir="rtl"></div>
              :
              isPayed == 0 //&& (additionalList.length > 0 && infoAdditionalHeader)
                ? <>
                  <div className="flex-row nice-gap-1rem nice-container mb-20 mt-16">
                    {
                      <div className="cart-finalized-code-Custom px-4"
                        onClick={() => {
                          if (sadadInfo && sadadInfo?.SadadNumber != null && sadadInfo.SadadNumber != 0) {
                            navigator.clipboard.writeText(sadadInfo?.SadadNumber ? sadadInfo?.SadadNumber : "");
                            toast.success(trans("messages:copied_successfully"));
                          }
                        }}
                      >
                        <span className="text-34 font-bold text-white mx-2">
                          {
                            sadadInfo?.SadadNumber
                              ? (
                                trans("new:Prepaid") + "   " + trans('jobCard:agreement_number') + "   "
                              )
                              : trans("new:Prepaid")
                          }
                        </span>

                        <code className="text-white text-30 language-en">
                          {
                            sadadInfo?.SadadNumber
                              ? (sadadInfo?.SadadNumber ? sadadInfo?.SadadNumber : "")
                              : postedDate && moment(postedDate).format('hh:mm a').toUpperCase()
                          }
                        </code>

                        <code className="text-white text-30">
                          {sadadInfo?.SadadNumber
                            ? <img src="/assets/icons/copy.svg" alt='copy' />
                            : postedDate && moment(postedDate).format('DD/MM/yyyy')}
                        </code>
                        {/*<img src="/assets/icons/copy.svg" alt='copy' />*/}
                      </div>
                    }
                  </div>
                </>
                :
                <>
                  {
                    isLoading == true
                      ? <div className="text-white text-20 basis-2/4 my-10 order-1" dir="rtl">
                        <SimpleButton
                          className="text-white bg-gray text-20 basis-2/4 my-10 order-1 mx-24"
                          isLoading={isLoading}
                          title={''}
                          onClick={() => {
                          }}
                        />
                      </div>
                      : <div className="flex flex-row nice-gap-2rem my-20 nice-container" dir="rtl">
                        <SimpleButton
                          className="text-white bg-primary text-20 basis-2/4 my-10 order-1"

                          isLoading={isLoading}
                          title={trans("complete_order")}
                          onClick={() => {
                            ////console.log("osama >>>>>>>>>>>>>>>>>>>>");
                            handelGoCheckSms(false);
                          }}
                        />
                        <SimpleButton
                          isLoading={isLoading}
                          className="text-white bg-black basis-2/4 my-10"
                          iconPath={'/assets/icons/apple-pay.png'}
                          onClick={() => {

                            handelGoCheckSms(true);

                            // setShowFinalPopup(true);
                            // window.location.replace("https://secure.paytabs.sa/payment/request/invoice/1288115/B2C960375A1C475BBF7C70216CB629A9");
                            //OSAMA tests
                          }}
                        />
                      </div>
                  }
                </>
          }
        </div>


        <Suspense>
          <PopupWithHeading
            className={"popup-container-auto"}
            backButton={true}
            show={showPopup}
            title={optionTitle}
            onStatusChange={(status) => {

              setShowPopup(false);
            }}
          >
            <SMSCheck
              mobile={jobCardInfo && jobCardInfo["mobileNo"]}

              onSucess={onSucess}

            />
          </PopupWithHeading>


          <Popup show={showFinalPopup}>
            <div className="w-full h-full flex justify-center items-center">
              <div className="cart-finalized" ref={popRef}>
                {/* <div className="popup-close nice-select-none" onClick={() => {

                                setShowFinalPopup(false);

                            }}>
                                {"x"}
                            </div> */}
                <div className="cart-finalized-container">
                  <img src="/assets/images/finalized.svg" alt={'/assets/images/finalized.svg'} />
                </div>
                <div className="flex flex-wrap justify-center">
                  <span
                    className="text-34 font-bold text-black mx-2 unselectable ">{trans("new:thank_to_choose")}</span>
                  <span className="text-34 font-bold text-primary mx-2"> {trans("new:HJ_cars")}</span>
                </div>
                {
                  popupSectionCallback(orderStatusCode)
                }

                {
                  sadadInfo?.SadadNumber &&
                  <div className="cart-finalized-code"

                    onClick={() => {

                      navigator.clipboard.writeText(sadadInfo?.SadadNumber ? sadadInfo?.SadadNumber : "");
                      toast.success(trans("messages:copied_successfully"));
                    }}
                  >
                    <span
                      className="text-34 font-bold text-white mx-2">{trans('jobCard:agreement_number') + ":"}</span>
                    <code
                      className="text-white text-30">{sadadInfo?.SadadNumber ? sadadInfo?.SadadNumber : ""}</code>
                    <img src="/assets/icons/copy.svg" alt='copy' />
                  </div>
                }

                {/*{sadadInfo?.PaymentMethodID &&*/}
                {/*    <div className="flex flex-wrap justify-center">*/}
                {/*      <span className="text-34 font-bold text-black mx-2 unselectable ">{trans("new:deal_with") }</span>*/}
                {/*      <span className="text-34 font-bold text-primary mx-2"> {sadadInfo?.PaymentMethodID.toString() }</span>*/}
                {/*    </div>*/}
                {/*}*/}

              </div>
            </div>
          </Popup>

          <Popup show={showTermsPopup}>
            <div className="w-full h-full flex justify-center items-center">
              <div className="cart-finalized" ref={popRef}>
                <div className="popup-close nice-select-none" onClick={() => {

                  setShowTermsPopup(false);

                }}>
                  {"x"}
                </div>


              </div>
            </div>
          </Popup>

          <PopupWithHeading

            terms={true}
            backButton={false}
            show={showTermsPopup}
            title={trans("mobileCommon:cart_agreement_part2")}
            onStatusChange={(status) => {
              setShowTermsPopup(false);
            }}


          >

            <ul className="my-10 p-20 flex flex-col top-margin-t">
              {

                termsSalesOrders.map((term, index) => {
                  return (

                    term &&
                    <li key={index} className={"text-30  my-5 "}>
                      {
                        !term.includes("<>") &&
                        <>
                          <span className="text-30 text-bold ">{term}</span>
                        </>
                      }

                      {
                        term.includes("<>") &&
                        term.split('<>').slice(1).map((termsub, indexsub) => {
                          return (
                            termsub &&
                            <h6 key={indexsub} className="text-30 text-bold ">{"-"} <span
                              className="text-30 text-bold ">{termsub}</span></h6>

                          );
                        })
                      }
                    </li>
                  );
                })
              }


            </ul>

            {/*<div className="my-20 p-5 flex flex-col">*/}
            {/*  {*/}
            {/*    termsSalesOrders[0] &&*/}
            {/*    <img src={(lang == "ar" ? termsSalesOrders[0].imageAr : termsSalesOrders[0].imageEn) ? "data:image/png;base64," + (lang == "ar" ? termsSalesOrders[0].imageAr : termsSalesOrders[0].imageEn) : '/assets/images/default.png'} alt={""} />*/}
            {/*  }*/}
            {/*</div>*/}
          </PopupWithHeading>


        </Suspense>
      </div>
    ))
}
export default JobCard
